import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { NextSDREntityProvider, NextSDRDateTypes } from '@bds/next-sdr';
import * as i2 from '@angular/common';
const LOCALHOST_PORT = "10005";
var BaseUrlType;
(function (BaseUrlType) {
  BaseUrlType[BaseUrlType["Baborg"] = 0] = "Baborg";
  BaseUrlType[BaseUrlType["Messaggero"] = 1] = "Messaggero";
  BaseUrlType[BaseUrlType["Permessi"] = 2] = "Permessi";
  BaseUrlType[BaseUrlType["Login"] = 3] = "Login";
  BaseUrlType[BaseUrlType["PassTokenGenerator"] = 4] = "PassTokenGenerator";
  BaseUrlType[BaseUrlType["LogoutApi"] = 5] = "LogoutApi";
  BaseUrlType[BaseUrlType["Logout"] = 6] = "Logout";
  BaseUrlType[BaseUrlType["RefreshSessionInternauta"] = 7] = "RefreshSessionInternauta";
  BaseUrlType[BaseUrlType["Ribaltone"] = 8] = "Ribaltone";
  BaseUrlType[BaseUrlType["RibaltoneUtils"] = 9] = "RibaltoneUtils";
  BaseUrlType[BaseUrlType["Configurazione"] = 10] = "Configurazione";
  BaseUrlType[BaseUrlType["Shpeck"] = 11] = "Shpeck";
  BaseUrlType[BaseUrlType["ShpeckCommonParameters"] = 12] = "ShpeckCommonParameters";
  BaseUrlType[BaseUrlType["ConfigurazioneImpostazioniApplicazioni"] = 13] = "ConfigurazioneImpostazioniApplicazioni";
  BaseUrlType[BaseUrlType["Intimus"] = 14] = "Intimus";
  BaseUrlType[BaseUrlType["Rubrica"] = 15] = "Rubrica";
  BaseUrlType[BaseUrlType["Scrivania"] = 16] = "Scrivania";
  BaseUrlType[BaseUrlType["ScrivaniaCommonParameters"] = 17] = "ScrivaniaCommonParameters";
  BaseUrlType[BaseUrlType["Tools"] = 18] = "Tools";
  BaseUrlType[BaseUrlType["Scripta"] = 19] = "Scripta";
  BaseUrlType[BaseUrlType["Logs"] = 20] = "Logs";
  BaseUrlType[BaseUrlType["Titolario"] = 21] = "Titolario";
  // firma
  BaseUrlType[BaseUrlType["FirmaRemotaAruba"] = 22] = "FirmaRemotaAruba";
  BaseUrlType[BaseUrlType["FirmaJNJ"] = 23] = "FirmaJNJ";
  BaseUrlType[BaseUrlType["Versatore"] = 24] = "Versatore";
  BaseUrlType[BaseUrlType["Tip"] = 25] = "Tip";
  BaseUrlType[BaseUrlType["Lotti"] = 26] = "Lotti";
  BaseUrlType[BaseUrlType["Masterjobs"] = 27] = "Masterjobs";
})(BaseUrlType || (BaseUrlType = {}));
const BaseUrls = new Map([[BaseUrlType.Baborg, "/internauta-api/resources/baborg"], [BaseUrlType.Messaggero, "/internauta-api/resources/messaggero"], [BaseUrlType.Permessi, "/internauta-api/resources/permessi"], [BaseUrlType.Login, "/internauta-api/login"], [BaseUrlType.PassTokenGenerator, "/internauta-api/login/passtoken"], [BaseUrlType.LogoutApi, "/internauta-api/logout"], [BaseUrlType.RefreshSessionInternauta, "/internauta-api/refresh"], [BaseUrlType.Logout, "/Shibboleth.sso/Logout"], [BaseUrlType.Ribaltone, "/internauta-api/resources/baborg/ribaltone/lanciaRibaltone"], [BaseUrlType.RibaltoneUtils, "/internauta-api/resources/ribaltoneutils"], [BaseUrlType.Configurazione, "/internauta-api/resources/configurazione"], [BaseUrlType.Shpeck, "/internauta-api/resources/shpeck"], [BaseUrlType.ShpeckCommonParameters, "/internauta-api/resources/shpeck/getShpeckCommonParameters"], [BaseUrlType.ConfigurazioneImpostazioniApplicazioni, "/internauta-api/resources/configurazione/custom/setImpostazioniApplicazioni"], [BaseUrlType.Intimus, ""], [BaseUrlType.Rubrica, "/internauta-api/resources/rubrica"], [BaseUrlType.Scrivania, "/internauta-api/resources/scrivania"], [BaseUrlType.ScrivaniaCommonParameters, "/internauta-api/resources/scrivania/getScrivaniaCommonParameters"], [BaseUrlType.Tools, "/internauta-api/resources/tools"], [BaseUrlType.Scripta, "/internauta-api/resources/scripta"], [BaseUrlType.Logs, "/internauta-api/resources/logs"], [BaseUrlType.Titolario, "/internauta-api/resources/titolario"],
// firma
[BaseUrlType.FirmaRemotaAruba, "/firma-api/remota/aruba"], [BaseUrlType.FirmaJNJ, "/firma-api/jnj"], [BaseUrlType.Versatore, "/internauta-api/resources/versatore"], [BaseUrlType.Tip, "/internauta-api/resources/tip"], [BaseUrlType.Lotti, "/internauta-api/resources/lotti"], [BaseUrlType.Masterjobs, "/masterjobs-api/resources/masterjobs"]]);
function getInternautaUrl(type) {
  if (!BaseUrls.has(type)) {
    throw new Error("Failed to obtain internauta url, type does not exists!");
  }
  let port;
  const wl = window.location;
  if (wl.hostname === "localhost" && type === BaseUrlType.Intimus) {
    return "https://gdml.internal.ausl.bologna.it";
  }
  // if (type === BaseUrlType.Intimus) {
  //     port = INTIMUS_LOCALHOST_PORT;
  // } else {
  //     port = LOCALHOST_PORT;
  // }
  if (wl.hostname === "localhost") {
    port = LOCALHOST_PORT;
  } else {
    port = wl.port;
  }
  const out = wl.protocol + "//" + wl.hostname + ":" + port + BaseUrls.get(type);
  // console.log(out);
  return out;
}
const CUSTOM_SERVER_METHODS = {
  // baborg
  struttureAntenate: "struttureAntenate",
  downloadJnJClientSetup: "downloadJnJClientSetup",
  downloadCSVModel: "downloadCSVModel",
  getSimilarities: "getSimilarities",
  sendSelectedContactsToExternalApp: "sendSelectedContactsToExternalApp",
  salvaGruppo: "salvaGruppo",
  getDomicilioDigitaleFromCF: "getDomicilioDigitaleFromCF",
  getAndSaveDomicilioDigitale: "getAndSaveDomicilioDigitale",
  getDocDocByIdDocSorgente: "getDocDocByIdDocSorgente",
  getMonitoraggioByIdDoc: "getMonitoraggioByIdDoc"
};
const KRINT_TIPO_OGGETTO = {
  PEC: "PEC",
  PEC_MESSAGE: "PEC_MESSAGE",
  PEC_DRAFT: "PEC_DRAFT",
  BABORG_PEC: "BABORG_PEC",
  SHPECK_MESSAGE: "SHPECK_MESSAGE",
  SHPECK_DRAFT: "SHPECK_DRAFT",
  SHPECK_FOLDER: "SHPECK_FOLDER",
  SHPECK_TAG: "SHPECK_TAG",
  SHPECK_OUTBOX: "SHPECK_OUTBOX",
  RUBRICA_CONTATTO: "RUBRICA_CONTATTO",
  RUBRICA_DETTAGLIO_CONTATTO: "RUBRICA_DETTAGLIO_CONTATTO",
  RUBRICA_GRUPPO: "RUBRICA_GRUPPO",
  RUBRICA_GRUPPO_CONTATTO: "RUBRICA_GRUPPO_CONTATTO",
  BABORG_UFFICIO: "BABORG_UFFICIO",
  BABORG_ATTRIBUTI_STRUTTURA: "BABORG_ATTRIBUTI_STRUTTURA",
  BABORG_UTENTE_STRUTTURA: "BABORG_UTENTE_STRUTTURA",
  BABORG_STRUTTURA: "BABORG_STRUTTURA",
  BABORG_TIPOLOGIA_STRUTTURA: "BABORG_TIPOLOGIA_STRUTTURA",
  BABORG_PERSONA: "BABORG_PERSONA",
  SCRIPTA_ARCHIVIO: "SCRIPTA_ARCHIVIO",
  SCRIPTA_ATTORE_ARCHIVIO: "SCRIPTA_ATTORE_ARCHIVIO",
  SCRIPTA_ARCHIVIO_DOC: "SCRIPTA_ARCHIVIO_DOC",
  SCRIPTA_DOC: "SCRIPTA_DOC",
  TITOLARIO_TITOLO: "TITOLARIO_TITOLO",
  TITOLARIO_ALBERO: "TITOLARIO_ALBERO"
};
const CODICI_AZIENDA = {
  AUSLBO: "105",
  IOR: "960",
  AUSLPR: "102",
  AUSLFE: "109",
  AOSPBO: "908",
  AOSPFE: "909",
  AUSLIM: "106",
  AOSPPR: "902",
  AOVR: "050109",
  // azienda e codice regione
  AZERO: "100",
  ARPALUMBRIA: "999"
};
const AZIENDA_CORRENTE = "AZIENDA_CORRENTE";
const CODICI_RUOLO = {
  UG: "UG",
  // aziendale
  MOS: "MOS",
  // aziendale
  OS: "OS",
  // aziendale
  CA: "CA",
  // aziendale
  CI: "CI",
  // interaziendale
  AS: "AS",
  // interaziendale
  SD: "SD",
  // interaziendale
  R: "R",
  // utente_struttura
  RV: "RV",
  //aziendale
  IP: "IP",
  //aziendale
  AG: "AG" //aziendale
};
var MODULI_RUOLO;
(function (MODULI_RUOLO) {
  MODULI_RUOLO["GENERALE"] = "GENERALE";
  MODULI_RUOLO["MATRINT"] = "MATRINT";
  MODULI_RUOLO["POOLS"] = "POOLS";
})(MODULI_RUOLO || (MODULI_RUOLO = {}));
var FluxPermission;
(function (FluxPermission) {
  FluxPermission["REDIGE"] = "REDIGE";
  FluxPermission["FIRMA"] = "FIRMA";
  FluxPermission["SEGR"] = "SEGR";
  FluxPermission["DA"] = "DA";
  FluxPermission["DS"] = "DS";
  FluxPermission["DG"] = "DG";
  // aggiungere altri permessi di flusso all'occorrenza
})(FluxPermission || (FluxPermission = {}));
var PecPermission;
(function (PecPermission) {
  PecPermission["RISPONDE"] = "RISPONDE";
  PecPermission["LEGGE"] = "LEGGE";
  PecPermission["ELIMINA"] = "ELIMINA";
  PecPermission["SPEDISCE"] = "SPEDISCE";
  // aggiungere altri permessi di pec all'occorrenza
})(PecPermission || (PecPermission = {}));
var ParametriAzienda;
(function (ParametriAzienda) {
  ParametriAzienda["FIRMA_REMOTA_CONFIGURATION"] = "firmaRemotaConfiguration";
})(ParametriAzienda || (ParametriAzienda = {}));
const AFFERENZA_STRUTTURA = {
  DIRETTA: 1,
  FUNZIONALE: 3,
  UNIFICATA: 9,
  TEST: 7
};
var TipologieDocumentiTip;
(function (TipologieDocumentiTip) {
  TipologieDocumentiTip["PU"] = "PROTOCOLLO_IN_USCITA";
  TipologieDocumentiTip["PE"] = "PROTOCOLLO_IN_ENTRATA";
  TipologieDocumentiTip["DELI"] = "DELIBERA";
  TipologieDocumentiTip["DETE"] = "DETERMINA";
  TipologieDocumentiTip["ARCHIVI"] = "FASCICOLO";
})(TipologieDocumentiTip || (TipologieDocumentiTip = {}));
const ENTITIES_STRUCTURE = {
  baborg: {
    afferenzastruttura: {
      path: "afferenzastruttura",
      standardProjections: {
        AfferenzaStrutturaWithPlainFields: "AfferenzaStrutturaWithPlainFields"
      },
      customProjections: {},
      collectionResourceRel: "afferenzastruttura",
      keyName: "id"
    },
    importazioniorganigramma: {
      path: "importazioniorganigramma",
      standardProjections: {
        ImportazioniOrganigrammaWithIdAziendaAndIdPersona: "ImportazioniOrganigrammaWithIdAziendaAndIdPersona"
      },
      customProjections: {},
      collectionResourceRel: "importazioniorganigramma",
      keyName: "id"
    },
    azienda: {
      path: "azienda",
      standardProjections: {},
      customProjections: {
        AziendaWithRibaltoneDaLanciareListCustom: "AziendaWithRibaltoneDaLanciareListCustom",
        CustomAziendaDescriptionFields: "CustomAziendaDescriptionFields"
      },
      collectionResourceRel: "azienda",
      keyName: "id"
    },
    tipologiastruttura: {
      path: "tipologiastruttura",
      standardProjections: {
        TipologiaStrutturaWithPlainFields: "TipologiaStrutturaWithPlainFields"
      },
      customProjections: {},
      collectionResourceRel: "tipologiastruttura",
      keyName: "id"
    },
    attributistruttura: {
      path: "attributistruttura",
      standardProjections: {
        AttributiStrutturaWithIdStrutturaAndIdTipologiaStruttura: "AttributiStrutturaWithIdStrutturaAndIdTipologiaStruttura",
        AttributiStrutturaWithIdTipologiaStruttura: "AttributiStrutturaWithIdTipologiaStruttura",
        AttributiStrutturaWithPlainFields: "AttributiStrutturaWithPlainFields"
      },
      customProjections: {},
      collectionResourceRel: "attributistruttura",
      keyName: "id"
    },
    struttura: {
      path: "struttura",
      standardProjections: {
        StrutturaWithWithPlainFields: "StrutturaWithWithPlainFields",
        StrutturaWithIdAzienda: "StrutturaWithIdAzienda",
        StrutturaWithAttributiStrutturaAndIdAzienda: "StrutturaWithAttributiStrutturaAndIdAzienda",
        StrutturaWithIdAziendaAndUtenteStrutturaList: "StrutturaWithIdAziendaAndUtenteStrutturaList",
        StrutturaWithIdAziendaAndIdStrutturaPadre: "StrutturaWithIdAziendaAndIdStrutturaPadre",
        StrutturaWithAttributiStrutturaAndIdAziendaAndIdStrutturaPadre: "StrutturaWithAttributiStrutturaAndIdAziendaAndIdStrutturaPadre",
        StrutturaWitStruttureFiglieList: "StrutturaWitStruttureFiglieList"
      },
      customProjections: {
        StrutturaWithAttributiStrutturaIdAziendaIdStrutturaPadreExpandedCustom: "StrutturaWithAttributiStrutturaIdAziendaIdStrutturaPadreExpandedCustom",
        UfficioWithStruttureConnesseCustom: "UfficioWithStruttureConnesseCustom",
        UtenteStrutturaWithIdAfferenzaStrutturaCustom: "UtenteStrutturaWithIdAfferenzaStrutturaCustom"
      },
      collectionResourceRel: "struttura",
      keyName: "id"
    },
    storicorelazione: {
      path: "storicorelazione",
      standardProjections: {
        StoricoRelazioneWithIdStrutturaFiglia: "StoricoRelazioneWithIdStrutturaFiglia",
        StoricoRelazioneWithIdStrutturaFigliaAndIdStrutturaPadre: "StoricoRelazioneWithIdStrutturaFigliaAndIdStrutturaPadre",
        StoricoRelazioneWithIdStrutturaPadre: "StoricoRelazioneWithIdStrutturaPadre",
        StoricoRelazioneWithPlainFields: "StoricoRelazioneWithPlainFields"
      },
      customProjections: {
        StoricoRelazioneWithIdStrutturaFigliaCustom: "StoricoRelazioneWithIdStrutturaFigliaCustom"
      },
      collectionResourceRel: "storicorelazione",
      keyName: "id"
    },
    utente: {
      path: "utente",
      standardProjections: {
        UtenteWithIdAziendaAndIdPersona: "UtenteWithIdAziendaAndIdPersona"
      },
      customProjections: {
        UtenteWithIdPersonaAndPermessiCustom: "UtenteWithIdPersonaAndPermessiCustom",
        UtenteWithIdPersonaAndPermessiByIdUtenteCustom: "UtenteWithIdPersonaAndPermessiByIdUtenteCustom"
      },
      collectionResourceRel: "utente",
      keyName: "id"
    },
    utentestruttura: {
      path: "utentestruttura",
      standardProjections: {
        UtenteStrutturaWithPlainFields: "UtenteStrutturaWithPlainFields",
        UtenteStrutturaWithIdAfferenzaStrutturaAndIdStruttura: "UtenteStrutturaWithIdAfferenzaStrutturaAndIdStruttura"
      },
      customProjections: {
        UtenteStrutturaWithIdAfferenzaStrutturaCustom: "UtenteStrutturaWithIdAfferenzaStrutturaCustom",
        UtenteStrutturaWithAfferenzaPrimaraCustom: "UtenteStrutturaWithAfferenzaPrimaraCustom",
        UtenteStrutturaExpandedCustom: "UtenteStrutturaExpandedCustom"
      },
      collectionResourceRel: "utentestruttura",
      keyName: "id"
    },
    strutturaunificata: {
      path: "strutturaunificata",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "strutturaunificata",
      keyName: "id"
    },
    pec: {
      path: "pec",
      standardProjections: {
        PecWithPlainFields: "PecWithPlainFields",
        PecWithTagList: "PecWithTagList",
        PecWithFolderList: "PecWithFolderList",
        PecWithFolderListAndTagList: "PecWithFolderListAndTagList",
        PecWithFolderListAndPecAziendaList: "PecWithFolderListAndPecAziendaList",
        PecWithFolderListAndPecAziendaListAndTagList: "PecWithFolderListAndPecAziendaListAndTagList"
      },
      customProjections: {
        CustomPecWithFolderListAndPecAziendaListAndTagList: "CustomPecWithFolderListAndPecAziendaListAndTagList",
        PecPlainWithPermessiAndGestoriCustom: "PecPlainWithPermessiAndGestoriCustom",
        PecPlainWithStruttureAndGestoriCustom: "PecPlainWithStruttureAndGestoriCustom",
        PecWithPecProviderAndAziendaCustom: "PecWithPecProviderAndAziendaCustom"
      },
      collectionResourceRel: "pec",
      keyName: "id"
    },
    persona: {
      path: "persona",
      standardProjections: {
        PersonaWithPlainFields: "PersonaWithPlainFields",
        PersonaWithUtenteList: "PersonaWithUtenteList",
        PersonaWithAttivitaList: "PersonaWithAttivitaList",
        PersonaWithAttivitaListAndUtenteList: "PersonaWithAttivitaListAndUtenteList",
        PersonaWithAttivitaFattaList: "PersonaWithAttivitaFattaList",
        PersonaWithAttivitaFattaListAndUtenteList: "PersonaWithAttivitaFattaListAndUtenteList",
        PersonaWithAttivitaFattaListAndAttivitaList: "PersonaWithAttivitaFattaListAndAttivitaList",
        PersonaWithAttivitaFattaListAndAttivitaListAndUtenteList: "PersonaWithAttivitaFattaListAndAttivitaListAndUtenteList",
        PersonaWithImpostazioniApplicazioniList: "PersonaWithImpostazioniApplicazioniList"
      },
      customProjections: {
        PersonaPlainWithPermessiCustom: "PersonaPlainWithPermessiCustom",
        CustomPersonaLogin: "CustomPersonaLogin"
      },
      collectionResourceRel: "persona",
      keyName: "id"
    },
    pecprovider: {
      path: "pecprovider",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "pecprovider",
      keyName: "id"
    },
    pecazienda: {
      path: "pecazienda",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "pecazienda",
      keyName: "id"
    }
  },
  messaggero: {
    amministrazionemessaggio: {
      path: "amministrazionemessaggio",
      standardProjections: {
        AmministrazioneMessaggioWithPlainFields: "AmministrazioneMessaggioWithPlainFields"
      },
      customProjections: {},
      collectionResourceRel: "amministrazionemessaggio",
      keyName: "id"
    },
    templatemessaggio: {
      path: "templatemessaggio",
      standardProjections: {
        TemplateMessaggioWithPlainFields: "TemplateMessaggioWithPlainFields"
      },
      customProjections: {},
      collectionResourceRel: "templatemessaggio",
      keyName: "id"
    }
  },
  titolario: {
    titolo: {
      path: "titolo",
      standardProjections: {
        TitoloWithPlainFields: "TitoloWithPlainFields"
      },
      customProjections: {},
      collectionResourceRel: "titolo",
      keyName: "id"
    },
    massimario: {
      path: "massimario",
      standardProjections: {
        MassimarioWithPlainFields: "MassimarioWithPlainFields"
      },
      customProjections: {},
      collectionResourceRel: "massimario",
      keyName: "id"
    },
    massimariotitolo: {
      path: "massimariotitolo",
      standardProjections: {
        MassimarioTitoloWithPlainFields: "MassimarioTitoloWithPlainFields"
      },
      customProjections: {},
      collectionResourceRel: "massimariotitolo",
      keyName: "id"
    },
    registrocreazione: {
      path: "registrocreazione",
      standardProjections: {
        RegistroCreazioneWithPlainFields: "RegistroCreazioneWithPlainFields"
      },
      customProjections: {},
      collectionResourceRel: "registrocreazione",
      keyName: "id"
    },
    versione: {
      path: "versione",
      standardProjections: {
        VersioneWithPlainFields: "VersioneWithPlainFields"
      },
      customProjections: {},
      collectionResourceRel: "versione",
      keyName: "id"
    }
  },
  permessi: {
    ambitisemantici: {
      path: "ambitosemantico",
      standardProjections: {
        AmbitoSemanticoWithPlainFields: "AmbitoSemanticoWithPlainFields"
      },
      customProjections: {
        AmbitiSemanticiWithPredicatiExpanded: "AmbitiSemanticiWithPredicatiExpanded",
        AmbitiSemanticiWithPredicatiAmbitiExpanded: "AmbitiSemanticiWithPredicatiAmbitiExpanded"
      },
      collectionResourceRel: "ambitosemantico",
      keyName: "id"
    }
  },
  scrivania: {
    attivita: {
      path: "attivita",
      standardProjections: {},
      customProjections: {
        AttivitaWithIdApplicazioneAndIdAziendaAndTransientFields: "AttivitaWithIdApplicazioneAndIdAziendaAndTransientFields"
      },
      collectionResourceRel: "attivita",
      keyName: "id"
    },
    attivitafatta: {
      path: "attivitafatta",
      standardProjections: {},
      customProjections: {
        AttivitaFattaWithIdApplicazioneAndIdAziendaAndTransientFields: "AttivitaFattaWithIdApplicazioneAndIdAziendaAndTransientFields"
      },
      collectionResourceRel: "attivitafatta",
      keyName: "id"
    },
    menu: {
      path: "menu",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "menu",
      keyName: "id"
    },
    autorizzatoremodifichedocumentali: {
      path: "autorizzatoremodifichedocumentali",
      standardProjections: {
        AutorizzatoreModificheDocumentaliWithIdPersona: "AutorizzatoreModificheDocumentaliWithIdPersona"
      },
      customProjections: {},
      collectionResourceRel: "autorizzatoremodifichedocumentali",
      keyName: "id"
    }
  },
  configurazione: {
    applicazione: {
      path: "applicazione",
      standardProjections: {
        ApplicazioneWithPlainFields: "ApplicazioneWithPlainFields"
      },
      customProjections: {},
      collectionResourceRel: "applicazione",
      keyName: "id"
    },
    impostazioniapplicazioni: {
      path: "impostazioniapplicazioni",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "impostazioniapplicazioni",
      keyName: "id"
    },
    parametroaziende: {
      path: "parametroaziende",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "parametroaziende",
      keyName: "id"
    },
    firmepersona: {
      path: "firmepersona",
      standardProjections: {
        FirmePersonaWithPlainFields: "FirmePersonaWithPlainFields"
      },
      customProjections: {},
      collectionResourceRel: "firmepersona",
      keyName: "id"
    },
    dominiofirma: {
      path: "dominiofirma",
      standardProjections: {
        DominioFirmaWithPlainFields: "DominioFirmaWithPlainFields"
      },
      customProjections: {},
      collectionResourceRel: "dominiofirma",
      keyName: "codice"
    }
  },
  shpeck: {
    message: {
      path: "message",
      standardProjections: {},
      customProjections: {
        CustomMessageForMailList: "CustomMessageForMailList",
        CustomRecepitWithAddressList: "CustomRecepitWithAddressList"
      },
      collectionResourceRel: "message",
      keyName: "id"
    },
    messagewithfolderview: {
      path: "messagewithfolderview",
      standardProjections: {},
      customProjections: {
        CustomMessageWithFolderViewForMailList: "CustomMessageWithFolderViewForMailList"
      },
      collectionResourceRel: "messagewithfolderview",
      keyName: "id"
    },
    messagewithtagview: {
      path: "messagewithtagview",
      standardProjections: {},
      customProjections: {
        CustomMessageWithTagViewForMailList: "CustomMessageWithTagViewForMailList"
      },
      collectionResourceRel: "messagewithtagview",
      keyName: "id"
    },
    projectedmessage: {
      path: "projectedmessage",
      standardProjections: {
        ProjectedMessageWithPlainFields: "ProjectedMessageWithPlainFields"
      },
      customProjections: {},
      collectionResourceRel: "projectedmessage",
      keyName: "id"
    },
    projectedmessagefortagfilter: {
      path: "projectedmessagefortagfilter",
      standardProjections: {
        ProjectedMessageForTagFilterWithPlainFields: "ProjectedMessageForTagFilterWithPlainFields"
      },
      customProjections: {},
      collectionResourceRel: "projectedmessagefortagfilter",
      keyName: "id"
    },
    recepit: {
      path: "recepit",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "recepit",
      keyName: "id"
    },
    address: {
      path: "address",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "address",
      keyName: "id"
    },
    messageaddress: {
      path: "messageaddress",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "messageaddress",
      keyName: "id"
    },
    folder: {
      path: "folder",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "folder",
      keyName: "id"
    },
    messagefolder: {
      path: "messagefolder",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "messagefolder",
      keyName: "id"
    },
    tag: {
      path: "tag",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "tag",
      keyName: "id"
    },
    messagetag: {
      path: "messagetag",
      standardProjections: {
        MessageTagWithIdTag: "MessageTagWithIdTag",
        MessageTagWithIdMessage: "MessageTagWithIdMessage",
        MessageTagWithIdTagAndIdUtente: "MessageTagWithIdTagAndIdUtente",
        MessageTagWithIdMessageAndIdTag: "MessageTagWithIdMessageAndIdTag",
        MessageTagWithIdMessageAndIdTagAndIdUtente: "MessageTagWithIdMessageAndIdTagAndIdUtente"
      },
      customProjections: {},
      collectionResourceRel: "messagetag",
      keyName: "id"
    },
    rawmessage: {
      path: "rawmessage",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "rawmessage",
      keyName: "id"
    },
    draft: {
      path: "draft",
      standardProjections: {},
      customProjections: {
        CustomDraftWithPlainFields: "CustomDraftWithPlainFields"
      },
      collectionResourceRel: "draft",
      keyName: "id"
    },
    draftlite: {
      path: "draftlite",
      standardProjections: {
        DraftLiteWithPlainFields: "DraftLiteWithPlainFields",
        DraftLiteWithIdPec: "DraftLiteWithIdPec"
      },
      customProjections: {},
      collectionResourceRel: "draftlite",
      keyName: "id"
    },
    outbox: {
      path: "outbox",
      standardProjections: {},
      customProjections: {
        CustomOutboxWithPlainFields: "CustomOutboxWithPlainFields"
      },
      collectionResourceRel: "outbox",
      keyName: "id"
    },
    outboxLite: {
      path: "outboxLite",
      standardProjections: {
        OutboxLiteWithPlainFields: "OutboxLiteWithPlainFields",
        OutboxLiteWithIdPec: "OutboxLiteWithIdPec"
      },
      customProjections: {},
      collectionResourceRel: "outboxLite",
      keyName: "id"
    },
    note: {
      path: "note",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "note",
      keyName: "id"
    }
  },
  ribaltoneutils: {
    ribaltonedalanciare: {
      path: "ribaltonedalanciare",
      standardProjections: {
        RibaltoneDaLanciareWithIdAziendaAndIdUtente: "RibaltoneDaLanciareWithIdAziendaAndIdUtente"
      },
      customProjections: {
        RibaltoneDaLanciareWithIdAziendaAndIdUtenteCustom: "RibaltoneDaLanciareWithIdAziendaAndIdUtenteCustom"
      },
      collectionResourceRel: "ribaltonedalanciare",
      keyName: "id"
    },
    storicoattivazione: {
      path: "storicoattivazione",
      standardProjections: {
        StoricoAttivazioneWithIdUtente: "StoricoAttivazioneWithIdUtente",
        StoricoAttivazioneWithIdAziendaAndIdUtente: "StoricoAttivazioneWithIdAziendaAndIdUtente"
      },
      customProjections: {
        StoricoAttivazioneWithIdUtenteCustom: "StoricoAttivazioneWithIdUtenteCustom"
      },
      collectionResourceRel: "storicoattivazione",
      keyName: "id"
    }
  },
  rubrica: {
    contatto: {
      path: "contatto",
      standardProjections: {
        ContattoWithPlainFields: "ContattoWithPlainFields",
        ContattoWithIdPersonaAndIdPersonaCreazioneAndIdStruttura: "ContattoWithIdPersonaAndIdPersonaCreazioneAndIdStruttura",
        ContattoWithEmailListAndIdPersonaAndIdPersonaCreazioneAndIndirizziListAndTelefonoList: "ContattoWithEmailListAndIdPersonaAndIdPersonaCreazioneAndIndirizziListAndTelefonoList",
        // tslint:disable-next-line:max-line-length
        ContattoWithContattiDelGruppoListAndEmailListAndGruppiDelContattoListAndIdContattoPadreAndIdPersonaAndIdPersonaCreazioneAndIdStrutturaAndIdUtenteCreazioneAndIndirizziListAndTelefonoList: "ContattoWithContattiDelGruppoListAndEmailListAndGruppiDelContattoListAndIdContattoPadreAndIdPersonaAndIdPersonaCreazioneAndIdStrutturaAndIdUtenteCreazioneAndIndirizziListAndTelefonoList"
      },
      customProjections: {
        CustomContattoGruppoDetail: "CustomContattoGruppoDetail",
        CustomContattoEsternoDetail: "CustomContattoEsternoDetail"
      },
      collectionResourceRel: "contatto",
      keyName: "id"
    },
    contattocondettaglioprincipale: {
      path: "contattocondettaglioprincipale",
      standardProjections: {
        ContattoConDettaglioPrincipaleWithPlainFields: "ContattoConDettaglioPrincipaleWithPlainFields",
        ContattoConDettaglioPrincipaleWithIdPersonaCreazioneAndIdStruttura: "ContattoConDettaglioPrincipaleWithIdPersonaCreazioneAndIdStruttura"
      },
      customProjections: {
        CustomContattoListFast: "CustomContattoListFast"
      },
      collectionResourceRel: "contattocondettaglioprincipale",
      keyName: "id"
    },
    gruppiContatti: {
      path: "gruppiContatti",
      standardProjections: {
        gruppiContattiWithPlainFields: "gruppiContattiWithPlainFields"
      },
      customProjections: {},
      collectionResourceRel: "gruppiContatti",
      keyName: "id"
    },
    dettagliocontatto: {
      path: "dettagliocontatto",
      standardProjections: {
        DettaglioContattoWithPlainFields: "DettaglioContattoWithPlainFields",
        DettaglioContattoWithEmailAndIndirizzoAndTelefono: "DettaglioContattoWithEmailAndIndirizzoAndTelefono",
        DettaglioContattoWithIdContatto: "DettaglioContattoWithIdContatto",
        DettaglioContattoWithEmailAndIdContattoAndIndirizzoAndTelefono: "DettaglioContattoWithEmailAndIdContattoAndIndirizzoAndTelefono"
      },
      customProjections: {},
      collectionResourceRel: "dettagliocontatto",
      keyName: "id"
    }
  },
  scripta: {
    archiviodetail: {
      path: "archiviodetail",
      standardProjections: {
        ArchivioDetailWithIdAziendaAndIdPersonaCreazioneAndIdPersonaResponsabileAndIdStruttura: "ArchivioDetailWithIdAziendaAndIdPersonaCreazioneAndIdPersonaResponsabileAndIdStruttura"
      },
      customProjections: {
        CustomArchivioDetailExtended: "CustomArchivioDetailExtended"
      },
      collectionResourceRel: "archiviodetail",
      keyName: "id"
    },
    archiviodetailview: {
      path: "archiviodetailview",
      standardProjections: {
        ArchivioDetailViewWithIdAziendaAndIdPersonaCreazioneAndIdPersonaResponsabileAndIdStruttura: "ArchivioDetailViewWithIdAziendaAndIdPersonaCreazioneAndIdPersonaResponsabileAndIdStruttura"
      },
      customProjections: {
        CustomArchivioDetailViewExtended: "CustomArchivioDetailViewExtended"
      },
      collectionResourceRel: "archiviodetailview",
      keyName: "id"
    },
    archiviorecente: {
      path: "archiviorecente",
      standardProjections: {
        ArchivioRecenteWithIdPersona: "ArchivioRecenteWithIdPersona"
      },
      customProjections: {
        CustomArchivioRecenteWithIdArchivioDetail: "CustomArchivioRecenteWithIdArchivioDetail"
      },
      collectionResourceRel: "archiviorecente",
      keyName: "id"
    },
    permessoarchivio: {
      path: "permessoarchivio",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "permessoarchivio",
      keyName: "id"
    },
    archiviodiinteresse: {
      path: "archiviodiinteresse",
      standardProjections: {
        ArchivioDiInteresseWithPlainFields: "ArchivioDiInteresseWithPlainFields"
      },
      customProjections: {},
      collectionResourceRel: "archiviodiinteresse",
      keyName: "id"
    },
    attoredoc: {
      path: "attoredoc",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "attoredoc",
      keyName: "id"
    },
    attorearchivio: {
      path: "attorearchivio",
      standardProjections: {
        AttoreArchivioWithIdPersonaAndIdStruttura: "AttoreArchivioWithIdPersonaAndIdStruttura"
      },
      customProjections: {},
      collectionResourceRel: "attorearchivio",
      keyName: "id"
    },
    archivio: {
      path: "archivio",
      standardProjections: {
        ArchivioWithIdAziendaAndIdMassimarioAndIdTitolo: "ArchivioWithIdAziendaAndIdMassimarioAndIdTitolo"
      },
      customProjections: {
        CustomArchivioWithIdAziendaAndIdMassimarioAndIdTitolo: "CustomArchivioWithIdAziendaAndIdMassimarioAndIdTitolo"
      },
      collectionResourceRel: "archivio",
      keyName: "id"
    },
    archiviodoc: {
      path: "archiviodoc",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "archiviodoc",
      keyName: "id"
    },
    doc: {
      path: "doc",
      standardProjections: {
        DocWithIdAziendaAndIdPersonaCreazione: "DocWithIdAziendaAndIdPersonaCreazione",
        DocWithDestinatariAndIdAziendaAndIdPersonaCreazioneAndMittenti: "DocWithDestinatariAndIdAziendaAndIdPersonaCreazioneAndMittenti"
      },
      customProjections: {
        DocWithAll: "DocWithAll"
      },
      collectionResourceRel: "doc",
      keyName: "id"
    },
    docdetail: {
      path: "docdetail",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "docdetail",
      keyName: "id"
    },
    docdetailview: {
      path: "docdetailview",
      standardProjections: {
        DocDetailViewWithIdApplicazioneAndIdAziendaAndIdPersonaRedattriceAndIdPersonaResponsabileProcedimentoAndIdStrutturaRegistrazioneAndPermessoDocList: "DocDetailViewWithIdApplicazioneAndIdAziendaAndIdPersonaRedattriceAndIdPersonaResponsabileProcedimentoAndIdStrutturaRegistrazioneAndPermessoDocList"
      },
      customProjections: {},
      collectionResourceRel: "docdetailview",
      keyName: "id"
    },
    projecteddocdetail: {
      path: "projecteddocdetail",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "projecteddocdetail",
      keyName: "id"
    },
    projecteddocdetailwithpermessodoc: {
      path: "projecteddocdetailwithpermessodoc",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "projecteddocdetailwithpermessodoc",
      keyName: "id"
    },
    docdoc: {
      path: "docdoc",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "docdoc",
      keyName: "id"
    },
    permessodoc: {
      path: "permessodoc",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "permessodoc",
      keyName: "id"
    },
    mezzo: {
      path: "mezzo",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "mezzo",
      keyName: "id"
    },
    related: {
      path: "related",
      standardProjections: {
        RelatedWithIdContatto: "RelatedWithIdContatto",
        RelatedWithIdContattoAndIdGruppo: "RelatedWithIdContattoAndIdGruppo",
        RelatedWithIdGruppo: "RelatedWithIdGruppo",
        RelatedWithRelatedList: "RelatedWithRelatedList",
        RelatedWithSpedizioneList: "RelatedWithSpedizioneList"
      },
      customProjections: {},
      collectionResourceRel: "related",
      keyName: "id"
    },
    spedizione: {
      path: "spedizione",
      standardProjections: {
        SpedizioneWithIdMessageAndIdMezzo: "SpedizioneWithIdMessageAndIdMezzo",
        SpedizioneWithIdMezzo: "SpedizioneWithIdMezzo",
        SpedizioneWithIdMezzoAndIdRelated: "SpedizioneWithIdMezzoAndIdRelated",
        SpedizioneWithIdMezzoAndIdSmistamento: "SpedizioneWithIdMezzoAndIdSmistamento"
      },
      customProjections: {},
      collectionResourceRel: "spedizione",
      keyName: "id"
    },
    collegiosindacale: {
      path: "collegiosindacale",
      standardProjections: {
        CollegioSindacaleWithPlainFields: "CollegioSindacaleWithPlainFields"
      },
      customProjections: {},
      collectionResourceRel: "collegiosindacale",
      keyName: "id"
    },
    smistamento: {
      path: "smistamento",
      standardProjections: {
        SmistamentoWithIdStruttuta: "SmistamentoWithIdStruttuta"
      },
      customProjections: {},
      collectionResourceRel: "smistamento",
      keyName: "id"
    },
    allegato: {
      path: "allegato",
      standardProjections: {
        AllegatoWithIdAllegatoPadre: "AllegatoWithIdAllegatoPadre"
      },
      customProjections: {},
      collectionResourceRel: "allegato",
      keyName: "id"
    },
    massimario: {
      path: "massimario",
      standardProjections: {
        MassimarioWithTitoli: "MassimarioWithTitoli"
      },
      customProjections: {},
      collectionResourceRel: "massimario",
      keyName: "id"
    },
    titolo: {
      path: "titolo",
      standardProjections: {
        TitoloWithPlainFields: "TitoloWithPlainFields"
      },
      customProjections: {},
      collectionResourceRel: "titolo",
      keyName: "id"
    },
    noteversamento: {
      path: "noteversamento",
      standardProjections: {
        NoteVersamentoWithPlainFields: "NoteVersamentoWithPlainFields"
      },
      customProjections: {},
      collectionResourceRel: "noteversamento",
      keyName: "id"
    },
    monitoraggio: {
      path: "monitoraggio",
      standardProjections: {
        MonitoraggioWithPlainFields: "MonitoraggioWithPlainFields"
      },
      customProjections: {},
      collectionResourceRel: "monitoraggio",
      keyName: "id"
    }
  },
  tip: {
    sessioneimportazione: {
      path: "sessioneimportazione",
      standardProjections: {
        SessioneImportazioneWithPlainFields: "SessioneImportazioneWithPlainFields"
      },
      customProjections: {},
      collectionResourceRel: "sessioneimportazione",
      keyName: "id"
    },
    importazionedocumento: {
      path: "importazionedocumento",
      standardProjections: {
        ImportazioneDocumentoWithPlainFields: "ImportazioneDocumentoWithPlainFields"
      },
      customProjections: {},
      collectionResourceRel: "importazionedocumento",
      keyName: "id"
    }
  },
  logs: {
    krint: {
      path: "krint",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "krint",
      keyName: "id"
    }
  },
  tools: {
    supportedfile: {
      path: "supportedfile",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "supportedfile",
      keyName: "id"
    }
  },
  versatore: {
    sessioneversamento: {
      path: "sessioneversamento",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "sessioneversamento",
      keyName: "id"
    },
    versamento: {
      path: "versamento",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "versamento",
      keyName: "id"
    },
    versamentoallegato: {
      path: "versamentoallegato",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "versamentoallegato",
      keyName: "id"
    }
  },
  lotti: {
    contraente: {
      path: "contraente",
      standardProjections: {
        ContraenteWithPlainFields: "ContraenteWithPlainFields"
      },
      customProjections: {},
      collectionResourceRel: "contraente",
      keyName: "id"
    },
    tipologia: {
      path: "tipologia",
      standardProjections: {
        TipologiaWithPlainFields: "TipologiaWithPlainFields"
      },
      customProjections: {},
      collectionResourceRel: "tipologia",
      keyName: "id"
    },
    ruolocomponente: {
      path: "ruolocomponente",
      standardProjections: {
        RuoloComponenteWithPlainFields: "RuoloComponenteWithPlainFields"
      },
      customProjections: {},
      collectionResourceRel: "ruolocomponente",
      keyName: "id"
    },
    componente: {
      path: "componente",
      standardProjections: {
        ComponenteWithIdRuolo: "ComponenteWithIdRuolo"
      },
      customProjections: {},
      collectionResourceRel: "componente",
      keyName: "id"
    },
    gruppolotto: {
      path: "gruppolotto",
      standardProjections: {
        GruppoLottoWithComponentiList: "GruppoLottoWithComponentiList"
      },
      customProjections: {},
      collectionResourceRel: "gruppolotto",
      keyName: "id"
    },
    lotto: {
      path: "lotto",
      standardProjections: {
        LottoWithGruppiListAndIdContraenteAndIdDocAndIdTipologia: "LottoWithGruppiListAndIdContraenteAndIdDocAndIdTipologia"
      },
      customProjections: {
        LottoWithAll: "LottoWithAll"
      },
      collectionResourceRel: "lotto",
      keyName: "id"
    }
  },
  masterjobs: {
    job: {
      path: "job",
      standardProjections: {
        JobWithPlainFields: "JobWithPlainFields"
      },
      customProjections: {},
      collectionResourceRel: "job",
      keyName: "id"
    }
  }
};
class AmministrazioneMessaggiService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.messaggero.amministrazionemessaggio, getInternautaUrl(BaseUrlType.Messaggero));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: AmministrazioneMessaggiService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: AmministrazioneMessaggiService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: AmministrazioneMessaggiService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class ApplicazioneService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.configurazione.applicazione, getInternautaUrl(BaseUrlType.Configurazione));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ApplicazioneService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ApplicazioneService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: ApplicazioneService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class AziendaService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.baborg.azienda, getInternautaUrl(BaseUrlType.Baborg));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: AziendaService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: AziendaService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: AziendaService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class AfferenzaStrutturaService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.baborg.afferenzastruttura, getInternautaUrl(BaseUrlType.Baborg));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: AfferenzaStrutturaService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: AfferenzaStrutturaService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: AfferenzaStrutturaService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class StrutturaService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.baborg.struttura, getInternautaUrl(BaseUrlType.Baborg));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /**
   * Metodo che data un' idStruttura ci restituisce un array con gli id delle sue strutture antenate
   * come primo elemento c'è il nodo radice e come ultimo il nodo passato come parametro
   * @param idStruttura la struttura di riferimento
   * RM 44811: Sostituita questa api con l'altra che si trova in StoricoRelazioneService
   */
  getStruttureAntenate(idStruttura) {
    console.log("StrutturaService", "getStruttureAntenate");
    const url = getInternautaUrl(BaseUrlType.Baborg) + "/" + CUSTOM_SERVER_METHODS.struttureAntenate + "/" + idStruttura;
    return this.http.get(url).toPromise().then(data => {
      return data;
    });
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: StrutturaService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: StrutturaService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: StrutturaService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class TipologiaStrutturaService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.baborg.tipologiastruttura, getInternautaUrl(BaseUrlType.Baborg));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: TipologiaStrutturaService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: TipologiaStrutturaService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: TipologiaStrutturaService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class TemplateMessaggiService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.messaggero.templatemessaggio, getInternautaUrl(BaseUrlType.Messaggero));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: TemplateMessaggiService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: TemplateMessaggiService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: TemplateMessaggiService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class UtenteService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.baborg.utente, getInternautaUrl(BaseUrlType.Baborg));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: UtenteService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: UtenteService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: UtenteService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class PersonaService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.baborg.persona, getInternautaUrl(BaseUrlType.Baborg));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: PersonaService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: PersonaService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: PersonaService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class StrutturaUnificataService extends NextSDREntityProvider {
  http;
  datepipe;
  classDescriptionLocal = "StrutturaUnificataService";
  constructor(http, datepipe) {
    super(http, datepipe, ENTITIES_STRUCTURE.baborg.strutturaunificata, getInternautaUrl(BaseUrlType.Baborg));
    this.http = http;
    this.datepipe = datepipe;
  }
  update(elementToUpdate) {
    return super.patchHttpCall(elementToUpdate, elementToUpdate.id);
  }
  insert(elementToInsert, datepipe) {
    return super.postHttpCall(elementToInsert);
  }
  delete(elementToDelete) {
    return super.deleteHttpCall(elementToDelete.id);
  }
  batch(batchOperations) {
    return super.batchHttpCall(batchOperations);
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: StrutturaUnificataService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: StrutturaUnificataService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: StrutturaUnificataService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class UtenteStrutturaService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.baborg.utentestruttura, getInternautaUrl(BaseUrlType.Baborg));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: UtenteStrutturaService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: UtenteStrutturaService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: UtenteStrutturaService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class AmbitiSemanticiService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.permessi.ambitisemantici, getInternautaUrl(BaseUrlType.Permessi));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: AmbitiSemanticiService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: AmbitiSemanticiService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: AmbitiSemanticiService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class StoricoRelazioneService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.baborg.storicorelazione, getInternautaUrl(BaseUrlType.Baborg));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /**
   * Metodo che data un' idStruttura ci restituisce un array con gli id delle sue strutture antenate
   * come primo elemento c'è il nodo radice e come ultimo il nodo passato come parametro
   * @param idStruttura la struttura di riferimento
   */
  getStruttureAntenateInStoricoRelazione(idStruttura, dataRiferimento) {
    console.log("StrutturaService", "getStruttureAntenate");
    const parametri = dataRiferimento ? "?dataRiferimento=" + dataRiferimento.getTime() : "";
    const url = getInternautaUrl(BaseUrlType.Baborg) + "/" + CUSTOM_SERVER_METHODS.struttureAntenate + "/" + idStruttura + parametri;
    return this.http.get(url).toPromise().then(data => {
      return data;
    });
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: StoricoRelazioneService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: StoricoRelazioneService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: StoricoRelazioneService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class ParametroAziendeService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.configurazione.parametroaziende, getInternautaUrl(BaseUrlType.Configurazione));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ParametroAziendeService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ParametroAziendeService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: ParametroAziendeService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class KrintService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.logs.krint, getInternautaUrl(BaseUrlType.Logs));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  getLogs(krintFilterOptions) {
    const url = getInternautaUrl(BaseUrlType.Logs) + "/get_logs";
    let parametri = "";
    parametri = this.addParameter(parametri, "codiciOperazioni", krintFilterOptions.codiciOperazioni);
    parametri = this.addParameter(parametri, "idOggetto", krintFilterOptions.idOggetto);
    parametri = this.addParameter(parametri, "tipoOggetto", krintFilterOptions.tipoOggetto);
    parametri = this.addParameter(parametri, "idUtente", krintFilterOptions.idUtente);
    parametri = this.addParameter(parametri, "idOggettoContenitore", krintFilterOptions.idOggettoContenitore);
    parametri = this.addParameter(parametri, "tipoOggettoContenitore", krintFilterOptions.tipoOggettoContenitore);
    parametri = this.addParameter(parametri, "dataDa", krintFilterOptions.dataDa);
    parametri = this.addParameter(parametri, "dataA", krintFilterOptions.dataA);
    return this._http.get(url + "?" + parametri);
  }
  addParameter(params, numeParametro, valore) {
    if (valore != null) {
      if (params !== "") {
        params += "&" + numeParametro + "=" + valore;
      } else {
        params = numeParametro + "=" + valore;
      }
    }
    return params;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: KrintService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: KrintService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: KrintService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class DocService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.scripta.doc, getInternautaUrl(BaseUrlType.Scripta));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: DocService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: DocService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: DocService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class RelatedService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.scripta.related, getInternautaUrl(BaseUrlType.Scripta));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: RelatedService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: RelatedService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: RelatedService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class MezzoService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.scripta.mezzo, getInternautaUrl(BaseUrlType.Scripta));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: MezzoService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: MezzoService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: MezzoService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class SpedizioneService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.scripta.spedizione, getInternautaUrl(BaseUrlType.Scripta));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: SpedizioneService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: SpedizioneService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: SpedizioneService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class SmistamentoService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.scripta.smistamento, getInternautaUrl(BaseUrlType.Scripta));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: SmistamentoService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: SmistamentoService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: SmistamentoService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class DominioFirmaService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.configurazione.dominiofirma, getInternautaUrl(BaseUrlType.Configurazione));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: DominioFirmaService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: DominioFirmaService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: DominioFirmaService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class FirmePersonaService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.configurazione.firmepersona, getInternautaUrl(BaseUrlType.Configurazione));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: FirmePersonaService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: FirmePersonaService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: FirmePersonaService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class DocDetailViewService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.scripta.docdetailview, getInternautaUrl(BaseUrlType.Scripta));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: DocDetailViewService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: DocDetailViewService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: DocDetailViewService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class DocDetailService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.scripta.docdetail, getInternautaUrl(BaseUrlType.Scripta));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: DocDetailService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: DocDetailService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: DocDetailService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class MonitoraggioService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.scripta.monitoraggio, getInternautaUrl(BaseUrlType.Scripta));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  getMonitoraggioByIdDoc(idDoc) {
    const url = getInternautaUrl(BaseUrlType.Scripta) + "/" + CUSTOM_SERVER_METHODS.getMonitoraggioByIdDoc + "/" + idDoc;
    return this._http.get(url);
  }
  isMonitoratoByIdEsterno(idEsterno) {
    const url = getInternautaUrl(BaseUrlType.Scripta) + "/" + "isMonitoratoByGuid" + "/" + idEsterno;
    return this.http.get(url);
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: MonitoraggioService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: MonitoraggioService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: MonitoraggioService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class InternautaModelModule {
  /** @nocollapse */static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: InternautaModelModule,
    deps: [],
    target: i0.ɵɵFactoryTarget.NgModule
  });
  /** @nocollapse */
  static ɵmod = i0.ɵɵngDeclareNgModule({
    minVersion: "14.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: InternautaModelModule
  });
  /** @nocollapse */
  static ɵinj = i0.ɵɵngDeclareInjector({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: InternautaModelModule,
    providers: [AmministrazioneMessaggiService, ApplicazioneService, AziendaService, AfferenzaStrutturaService, StrutturaService, TipologiaStrutturaService, StrutturaUnificataService, StoricoRelazioneService, TemplateMessaggiService, UtenteService, UtenteStrutturaService, PersonaService, AmbitiSemanticiService, ParametroAziendeService, DocService, DocDetailService, DocDetailViewService, RelatedService, MezzoService, SpedizioneService, SmistamentoService, KrintService, FirmePersonaService, DominioFirmaService, MonitoraggioService]
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: InternautaModelModule,
  decorators: [{
    type: NgModule,
    args: [{
      imports: [],
      declarations: [],
      exports: [],
      providers: [AmministrazioneMessaggiService, ApplicazioneService, AziendaService, AfferenzaStrutturaService, StrutturaService, TipologiaStrutturaService, StrutturaUnificataService, StoricoRelazioneService, TemplateMessaggiService, UtenteService, UtenteStrutturaService, PersonaService, AmbitiSemanticiService, ParametroAziendeService, DocService, DocDetailService, DocDetailViewService, RelatedService, MezzoService, SpedizioneService, SmistamentoService, KrintService, FirmePersonaService, DominioFirmaService, MonitoraggioService]
    }]
  }]
});
class AfferenzaStruttura {
  id;
  descrizione;
  codice;
  fk_utenteStrutturaSet;
  version;
  nextSdrDateInformation = {};
}
class Azienda {
  id;
  path;
  nome;
  parametri;
  parametriMap;
  descrizione;
  codice;
  schemaGru;
  aoo;
  codiceRegione;
  idAziendaGru;
  ribaltaInternauta;
  ribaltaArgo;
  ribaltoneDaLanciareList;
  fk_strutturaSet;
  fk_idpEntityIdSet;
  fk_pecSet;
  fk_utenteSet;
  version;
  urlCommands; // valorizzato quando stiamo usando la projection CustomAziendaLogin
  parametriAzienda; // valorizzato quando stiamo usando la projection CustomAziendaLogin
  nextSdrDateInformation = {};
}
class Persona {
  id;
  descrizione;
  nome;
  cognome;
  attiva;
  bitRuoli;
  codiceFiscale;
  permessi;
  impostazioniApplicazioniList;
  messaggiVisti;
  permessiPec;
  idContatto;
  accessibilita;
  idSecondario;
  version;
  utenteList;
  descToSearch;
  fk_utenteList;
  fk_idContatto;
  fk_idAziendaDefault;
  dataSpegnimento;
  nextSdrDateInformation = {
    dataSpegnimento: NextSDRDateTypes.ZonedDateTime
  };
}
class Struttura {
  id;
  codice;
  idCasella;
  idCasellaPadre;
  nome;
  attiva;
  dislocazione;
  spettrale;
  codiceDislocazione;
  usaSegreteriaBucataPadre;
  foglia;
  dataAttivazione;
  dataCessazione;
  anarchica;
  ufficio;
  idAzienda;
  idStrutturaReplicata;
  struttureReplicheList;
  idStrutturaPadre;
  idContatto;
  attributiStruttura;
  version;
  struttureFiglieList;
  fk_strutturaUnificataDestinazioneList;
  fk_strutturaUnificataSorgenteList;
  fk_idAzienda;
  fk_utenteStrutturaList;
  fk_idStrutturaSegreteria;
  fk_idStrutturaPadre;
  fk_struttureFiglieList;
  fk_struttureSegretariateList;
  fk_pecStrutturaList;
  fk_idStrutturaReplicata;
  fk_idContatto;
  fk_attributiStruttura;
  // transient
  isPermessoPecPrincipale;
  propagaPermessoPec;
  fogliaCalcolata;
  fusioni;
  nextSdrDateInformation = {
    dataAttivazione: NextSDRDateTypes.ZonedDateTime,
    dataCessazione: NextSDRDateTypes.ZonedDateTime
  };
}
class TipologiaStruttura {
  id;
  tipologia;
  associaStrutture;
  ruoli;
  predicati;
  version;
  nextSdrDateInformation = {};
}
class AttributiStruttura {
  id;
  idStruttura;
  idTipologiaStruttura;
  fk_idStruttura;
  fk_idTipologiaStruttura;
  nextSdrDateInformation = {};
}
class StrutturaUnificata {
  id;
  idStrutturaSorgente;
  idStrutturaDestinazione;
  tipoOperazione;
  dataAttivazione;
  dataDisattivazione;
  dataAccensioneAttivazione;
  dataInserimentoRiga;
  version;
  fk_idStrutturaSorgente;
  fk_idStrutturaDestinazione;
  nextSdrDateInformation = {
    dataAttivazione: NextSDRDateTypes.ZonedDateTime,
    dataDisattivazione: NextSDRDateTypes.ZonedDateTime,
    dataAccensioneAttivazione: NextSDRDateTypes.ZonedDateTime,
    dataInserimentoRiga: NextSDRDateTypes.ZonedDateTime
  };
}
class Ruolo {
  id;
  nome;
  nomeBreve;
  mascheraBit;
  superAziendale;
  version;
  nextSdrDateInformation = {};
}
class Utente {
  id;
  username;
  fax;
  dominio;
  email;
  emails;
  attivo;
  telefono;
  passwordHash;
  omonimia;
  bitRuoli;
  idInquadramento;
  idRuoloAziendale;
  idPersona;
  idAzienda;
  aziende; // nel caso del loggedUser è un lista di projection CustomAziendaLogin
  aziendeAttive;
  version;
  dataSpegnimento;
  nextSdrDateInformation = {
    dataSpegnimento: NextSDRDateTypes.ZonedDateTime
  };
  utenteStrutturaList;
  fk_idAzienda;
  fk_idPersona;
  fk_pecUtenteList;
  fk_utenteStrutturaList;
  // CAMPI TRANSIENT
  permessiDiFlusso;
  permessiFilteredByAdditionalData;
  ruoli;
  struttureDelSegretario;
  // contiene la mappa dei ruoli per i vari moduli applicativi (la chiave è il modulo, il valore sono i ruoli relativi a quel modulo)
  mappaRuoli;
  /**
   * tutti i ruoli di tutte le aziende della persona dell'utente, divisi per interaziendali e aziendali.
   * mappa in cui la chiave è il codiceAzienda e il valore la lista dei codici ruolo per quell'azienda
   * nel caso dei ruoli interaziendali la chiave è 'interaziendali'
   */
  ruoliUtentiPersona;
  utenteReale;
  permessiDiFlussoByCodiceAzienda;
  permessiGediByCodiceAzienda;
  // campo in CustomUtenteLogin
  aziendaLogin; // è in realtà la projection CustomAziendaLogin
  // CAMPI TRANSIENT NON PRESENTI NELL'ENTITA' BACKEND
  hasPermessoAvatar;
}
class UtenteStruttura {
  id;
  fk_idUtente;
  fk_idStruttura;
  fk_permessoSet;
  fk_idAfferenzaStruttura;
  fk_idStrutturaVeicolante;
  idUtente;
  idStruttura;
  idAfferenzaStruttura;
  idStrutturaVeicolante;
  idDettaglioContatto;
  version;
  attivoDal;
  attivoAl;
  attivo;
  bitRuoli;
  nextSdrDateInformation = {
    attivoAl: NextSDRDateTypes.ZonedDateTime,
    attivoDal: NextSDRDateTypes.ZonedDateTime
  };
}
class Pec {
  id;
  indirizzo;
  username;
  password;
  attiva;
  publicataIPA;
  messagePolicy;
  perRiservato;
  idPecProvider;
  fk_idPecProvider;
  idAzienda;
  fk_idAzienda;
  descrizione;
  massiva;
  chiusa;
  giorniBozza;
  pecAziendaList;
  tagList;
  folderList;
  version;
  nextSdrDateInformation = {};
}
class PecAzienda {
  id;
  dataInserimentoRiga;
  fk_idPec;
  fk_idAzienda;
  idAzienda;
  idPec;
  version;
  nextSdrDateInformation = {
    dataInserimentoRiga: NextSDRDateTypes.ZonedDateTime
  };
}
class PecProvider {
  id;
  descrizione;
  pec;
  host;
  port;
  protocol;
  host_out;
  port_out;
  protocol_out;
  version;
  nextSdrDateInformation = {};
}
class ImportazioniOrganigramma {
  id;
  nomeFile;
  idUtente;
  fk_idUtente;
  idPersona;
  fk_idPersona;
  idAzienda;
  fk_idAzienda;
  tipo;
  esito;
  dataInserimentoRiga;
  version;
  pathErrorCsv;
  nextSdrDateInformation = {
    dataInserimentoRiga: NextSDRDateTypes.ZonedDateTime
  };
}
class StoricoRelazione {
  id;
  idStrutturaPadre;
  idStrutturaFiglia;
  attivaDal;
  attivaAl;
  version;
  fk_idStrutturaPadre;
  fk_idStrutturaFiglia;
  nextSdrDateInformation = {
    attivaAl: NextSDRDateTypes.ZonedDateTime,
    attivaDal: NextSDRDateTypes.ZonedDateTime
  };
}
class AmministrazioneMessaggio {
  id;
  titolo;
  testo;
  idApplicazioni;
  idAziende;
  idStrutture;
  idPersone;
  perTutti;
  dataPubblicazione;
  invasivita;
  tipologia;
  severita;
  intervallo;
  dataScadenza;
  dataInserimento;
  dataUltimaModifica;
  version;
  nextSdrDateInformation = {
    dataPubblicazione: NextSDRDateTypes.ZonedDateTime,
    dataScdenza: NextSDRDateTypes.ZonedDateTime,
    dataInserimento: NextSDRDateTypes.ZonedDateTime,
    dataUltimaModifica: NextSDRDateTypes.ZonedDateTime
  };
}
const InvasivitaEnum = {
  LOGIN: "LOGIN",
  POPUP: "POPUP"
};
const SeveritaEnum = {
  INFO: "INFO",
  WARNING: "WARNING",
  ERROR: "ERROR"
};
const TipologiaEnum = {
  RIPRESENTA_CON_INTERVALLO: "RIPRESENTA_CON_INTERVALLO",
  MOSTRA_UNA_SOLA_VOLTA: "MOSTRA_UNA_SOLA_VOLTA",
  CONSENTI_SCELTA: "CONSENTI_SCELTA"
};
class TemplateMessaggio {
  id;
  nomeTemplate;
  titolo;
  testo;
  idApplicazioni;
  idAziende;
  idStrutture;
  idPersone;
  perTutti;
  invasivita;
  tipologia;
  severita;
  intervallo;
  dataInserimento;
  dataUltimaModifica;
  version;
  nextSdrDateInformation = {
    dataInserimento: NextSDRDateTypes.ZonedDateTime,
    dataUltimaModifica: NextSDRDateTypes.ZonedDateTime
  };
}
class Attivita {
  id;
  idAzienda;
  idApplicazione;
  idPersona;
  descrizione;
  tipo;
  oggetto;
  aperta;
  dataInserimentoRiga;
  dataUltimaModifica;
  note;
  provenienza;
  dataScadenza;
  priorita;
  oggettoEsterno;
  tipoOggettoEsterno;
  oggettoEsternoSecondario;
  tipoOggettoEsternoSecondario;
  datiAggiuntivi;
  allegati;
  classe;
  data;
  tags;
  urls;
  compiledUrls;
  version;
  nextSdrDateInformation = {
    data: NextSDRDateTypes.ZonedDateTime,
    dataScdenza: NextSDRDateTypes.ZonedDateTime,
    dataInserimentoRiga: NextSDRDateTypes.ZonedDateTime,
    dataUltimaModifica: NextSDRDateTypes.ZonedDateTime
  };
  fk_idAzienda;
  fk_idPersona;
  fk_idApplicazione;
}
class AttivitaFatta {
  id;
  idAzienda;
  idApplicazione;
  descrizione;
  tipo;
  oggetto;
  aperta;
  dataInserimentoRiga;
  dataUltimaModifica;
  note;
  provenienza;
  dataScadenza;
  priorita;
  oggettoEsterno;
  tipoOggettoEsterno;
  oggettoEsternoSecondario;
  tipoOggettoEsternoSecondario;
  datiAggiuntivi;
  allegati;
  classe;
  data;
  tags;
  urls;
  compiledUrls;
  version;
  nextSdrDateInformation = {
    data: NextSDRDateTypes.ZonedDateTime,
    dataScdenza: NextSDRDateTypes.ZonedDateTime,
    dataInserimentoRiga: NextSDRDateTypes.ZonedDateTime,
    dataUltimaModifica: NextSDRDateTypes.ZonedDateTime
  };
  fk_idAzienda;
  fk_idPersona;
  fk_idApplicazione;
}
class Menu {
  id;
  idAzienda;
  idApplicazione;
  descrizione;
  permessiSufficienti;
  openCommand;
  compiledUrl;
  version;
  nextSdrDateInformation = {};
  fk_idAzienda;
  fk_idApplicazione;
}
class AutorizzatoreModificheDocumentali {
  id;
  idPersona;
  idAzienda;
  email;
  dataInserimentoRiga;
  version;
  nextSdrDateInformation = {
    dataInserimentoRiga: NextSDRDateTypes.ZonedDateTime
  };
  fk_idAzienda;
  fk_idPersona;
}
class Applicazione {
  id;
  nome;
  baseUrl;
  indexPage;
  attivitaList;
  attivitaFattaList;
  menuList;
  urlGenerationStrategy;
  version;
  nextSdrDateInformation = {};
  fk_attivitaList;
  fk_attivitaFattaList;
  fk_menuList;
}
const UrlsGenerationStrategy = {
  TRUSTED_URL_WITH_CONTEXT_INFORMATION: "TRUSTED_URL_WITH_CONTEXT_INFORMATION",
  TRUSTED_URL_WITHOUT_CONTEXT_INFORMATION: "TRUSTED_URL_WITHOUT_CONTEXT_INFORMATION",
  RELATIVE_WITH_CONTEXT_INFORMATION: "RELATIVE_WITH_CONTEXT_INFORMATION",
  RELATIVE_WITHOUT_CONTEXT_INFORMATION: "RELATIVE_WITHOUT_CONTEXT_INFORMATION",
  ABSOLUTE_WITH_CONTEXT_INFORMATION: "ABSOLUTE_WITH_CONTEXT_INFORMATION",
  ABSOLUTE_WITHOUT_CONTEXT_INFORMATION: "ABSOLUTE_WITHOUT_CONTEXT_INFORMATION"
};
var Applicazioni;
(function (Applicazioni) {
  Applicazioni["scrivania"] = "scrivania";
  Applicazioni["babel"] = "babel";
  Applicazioni["deli"] = "deli";
  Applicazioni["dete"] = "dete";
  Applicazioni["procton"] = "procton";
  Applicazioni["verba"] = "verba";
  Applicazioni["ribaltorg"] = "ribaltorg";
  Applicazioni["pecg"] = "pecg";
  Applicazioni["gedi"] = "gediInt";
  Applicazioni["baborg"] = "baborg";
  Applicazioni["gipi"] = "gipi";
  Applicazioni["shpeck"] = "shpeck";
  Applicazioni["firmone"] = "firmone";
  Applicazioni["myaliseo"] = "myaliseo";
  Applicazioni["rubrica"] = "rubrica";
  Applicazioni["scripta"] = "scripta";
  Applicazioni["ngipi"] = "ngipi";
  Applicazioni["sai"] = "sai";
  Applicazioni["albi"] = "albi";
})(Applicazioni || (Applicazioni = {}));
class ImpostazioniApplicazioni {
  id;
  idPersona;
  idApplicazione;
  impostazioniVisualizzazione;
  version;
  nextSdrDateInformation = {};
  fk_idPersona;
  fk_idApplicazione;
}
class ParametroAziende {
  id;
  nome;
  valore;
  idApplicazioni;
  idAziende;
  version;
  nextSdrDateInformation = {};
}
class FirmePersona {
  id;
  idPersona;
  predefinita;
  tipo;
  tramite;
  additionalData; // ???
  password; // transient
  version;
  nextSdrDateInformation = {};
  fk_idPersona;
}
const TipiFirma = {
  CNS: "CNS",
  REMOTA: "REMOTA"
};
var TramiteFirma;
(function (TramiteFirma) {
  TramiteFirma["APPLET"] = "APPLET";
  TramiteFirma["WEBSTART"] = "WEBSTART";
  TramiteFirma["INFOCERT"] = "INFOCERT";
  TramiteFirma["ARUBA"] = "ARUBA";
  TramiteFirma["NAMIRIAL"] = "NAMIRIAL";
  TramiteFirma["JR"] = "JR";
  TramiteFirma["MEDAS"] = "MEDAS";
})(TramiteFirma || (TramiteFirma = {}));
;
class DominioFirma {
  codice;
  nome;
  version;
  nextSdrDateInformation = {};
}
const DominiFirma = {
  frAUSLBO: "frAUSLBO",
  frAUSLPR: "frAUSLPR",
  frAOPR: "frAOPR",
  frAslImola: "frAslImola",
  firma: "firma"
};
class Address {
  id;
  mailAddress;
  originalAddress;
  recipientType;
  version;
  nextSdrDateInformation = {};
  messageAddressList;
}
class Folder {
  id;
  name;
  description;
  type;
  additionalData;
  idPec;
  idUtente;
  messageFolderList;
  unreadMessages;
  version;
  nextSdrDateInformation = {};
  fk_idPec;
  fk_idUtente;
  fk_messageFolderList;
}
const FolderType = {
  DRAFT: "DRAFT",
  INBOX: "INBOX",
  OUTBOX: "OUTBOX",
  TRASH: "TRASH",
  SPAM: "SPAM",
  CUSTOM: "CUSTOM",
  SENT: "SENT",
  REGISTERED: "REGISTERED"
  // READDRESSED: "READDRESSED"
};
class Message {
  id;
  uuidMessage;
  idPec;
  idApplicazione;
  idRelated;
  subject;
  messageStatus;
  inOut;
  createTime;
  updateTime;
  receiveDateProvider;
  messageType;
  isPec;
  attachmentsNumber;
  uuidRepository;
  pathRepository;
  name;
  receiveTime;
  seen;
  idRecepit;
  idMessagePecgw;
  version;
  nextSdrDateInformation = {
    createTime: NextSDRDateTypes.ZonedDateTime,
    updateTime: NextSDRDateTypes.ZonedDateTime,
    receiveTime: NextSDRDateTypes.ZonedDateTime,
    receiveDateProvider: NextSDRDateTypes.ZonedDateTime
  };
  fk_idPec;
  fk_idRelated;
  fk_messageAddressList;
  fk_messageTagList;
  fk_messageFolderList;
  fk_idRelatedList;
  fk_noteList;
  messageAddressList;
  messageTagList;
  messageFolderList;
  messageDocList;
  idRelatedList;
  noteList;
}
const InOut = {
  IN: "IN",
  OUT: "OUT"
};
const MessageStatus = {
  RECEIVED: "RECEIVED",
  SENT: "SENT",
  TO_SEND: "TO_SEND",
  WAITING_RECEPIT: "WAITING_RECEPIT",
  ERROR: "ERROR",
  CONFIRMED: "CONFIRMED"
};
const MessageType = {
  ERROR: "ERROR",
  MAIL: "MAIL",
  PEC: "PEC",
  RECEPIT: "RECEPIT",
  DRAFT: "DRAFT"
};
class MessageAddress {
  id;
  address;
  addressRole;
  idAddress;
  idMessage;
  version;
  nextSdrDateInformation = {};
  fk_idAddress;
}
const AddresRoleType = {
  FROM: "FROM",
  TO: "TO",
  CC: "CC",
  REPLY_TO: "REPLY_TO"
};
class MessageDoc {
  id;
  idDoc;
  scope;
  tipo;
  dataInserimento;
  version;
  nextSdrDateInformation = {
    dataInserimento: NextSDRDateTypes.ZonedDateTime
  };
  fk_idDoc;
  fk_idMessage;
}
class MessageFolder {
  id;
  idMessage;
  idFolder;
  idUtente;
  inserted;
  deleted;
  notes;
  version;
  nextSdrDateInformation = {
    inserted: NextSDRDateTypes.ZonedDateTime
  };
  fk_idMessage;
  fk_idFolder;
  fk_idUtente;
  fk_idPreviousFolder;
  // Campi aggiuntivi quando si usa il ProjectedMessage
  idPreviousFolderTransient;
}
class MessageTag {
  id;
  idMessage;
  idTag;
  idUtente;
  inserted;
  additionalData;
  version;
  nextSdrDateInformation = {
    inserted: NextSDRDateTypes.ZonedDateTime
  };
  fk_idMessage;
  fk_idTag;
  fk_idUtente;
}
class Note {
  id;
  idMessage;
  idUtente;
  memo;
  createTime;
  updateTime;
  version;
  nextSdrDateInformation = {
    updateTime: NextSDRDateTypes.ZonedDateTime,
    createTime: NextSDRDateTypes.ZonedDateTime
  };
  fk_idMessage;
  fk_idUtente;
}
class Outbox {
  id;
  idPec;
  rawData;
  ignore;
  idApplicazione;
  externalId;
  inserted;
  subject;
  toAddresses;
  ccAddresses;
  hiddenRecipients;
  createTime;
  updateTime;
  attachmentsNumber;
  attachmentsName;
  body;
  version;
  nextSdrDateInformation = {
    inserted: NextSDRDateTypes.ZonedDateTime,
    createTime: NextSDRDateTypes.ZonedDateTime,
    updateTime: NextSDRDateTypes.ZonedDateTime
  };
}
class RawMessage {
  id;
  rawData;
  idMessage;
  version;
  nextSdrDateInformation = {};
  fk_idMessage;
}
class Recepit {
  id;
  idMessage;
  recepitType;
  version;
  nextSdrDateInformation = {};
}
const RecepitType = {
  ACCETTAZIONE: "ACCETTAZIONE",
  PREAVVISO_ERRORE_CONSEGNA: "PREAVVISO_ERRORE_CONSEGNA",
  PRESA_IN_CARICO: "PRESA_IN_CARICO",
  NON_ACCETTAZIONE: "NON_ACCETTAZIONE",
  RILEVAZIONE_VIRUS: "RILEVAZIONE_VIRUS",
  ERRORE_CONSEGNA: "ERRORE_CONSEGNA",
  CONSEGNA: "CONSEGNA"
};
class Draft {
  id;
  idPec;
  subject;
  toAddresses;
  ccAddresses;
  hiddenRecipients;
  createTime;
  updateTime;
  attachmentsNumber;
  attachmentsName;
  body;
  eml;
  idMessageRelated;
  messageRelatedType;
  idUtente;
  version;
  nextSdrDateInformation = {
    createTime: NextSDRDateTypes.ZonedDateTime,
    updateTime: NextSDRDateTypes.ZonedDateTime
  };
  fk_idPec;
  fk_idUtente;
  fk_idMessageRelated;
}
const MessageRelatedType = {
  REPLIED: "REPLIED",
  REPLIED_ALL: "REPLIED_ALL",
  FORWARDED: "FORWARDED"
};
class Tag {
  id;
  name;
  description;
  type;
  visible;
  firstLevel;
  additionalData;
  nextSdrDateInformation = {};
  idPec;
  messageTagList;
  version;
  fk_idPec;
  fk_messageTagList;
}
const TagType = {
  SYSTEM_INSERTABLE_DELETABLE: "SYSTEM_INSERTABLE_DELETABLE",
  SYSTEM_INSERTABLE_NOT_DELETABLE: "SYSTEM_INSERTABLE_NOT_DELETABLE",
  SYSTEM_NOT_INSERTABLE_DELETABLE: "SYSTEM_NOT_INSERTABLE_DELETABLE",
  SYSTEM_NOT_INSERTABLE_NOT_DELETABLE: "SYSTEM_NOT_INSERTABLE_NOT_DELETABLE",
  CUSTOM: "CUSTOM"
};
class DraftLite {
  id;
  idPec;
  subject;
  toAddresses;
  ccAddresses;
  hiddenRecipients;
  createTime;
  updateTime;
  attachmentsNumber;
  attachmentsName;
  body;
  idMessageRelated;
  messageRelatedType;
  nextSdrDateInformation = {
    createTime: NextSDRDateTypes.ZonedDateTime,
    updateTime: NextSDRDateTypes.ZonedDateTime
  };
  fk_idPec;
  fk_idMessageRelated;
}
class OutboxLite {
  id;
  idPec;
  ignore;
  idApplicazione;
  externalId;
  inserted;
  subject;
  toAddresses;
  ccAddresses;
  hiddenRecipients;
  createTime;
  updateTime;
  attachmentsNumber;
  attachmentsName;
  body;
  nextSdrDateInformation = {
    inserted: NextSDRDateTypes.ZonedDateTime,
    createTime: NextSDRDateTypes.ZonedDateTime,
    updateTime: NextSDRDateTypes.ZonedDateTime
  };
}
class MessageWithFolderView {
  id;
  uuidMessage;
  idPec;
  idApplicazione;
  idRelated;
  subject;
  messageStatus;
  inOut;
  createTime;
  updateTime;
  receiveDateProvider;
  messageType;
  isPec;
  attachmentsNumber;
  uuidRepository;
  pathRepository;
  name;
  receiveTime;
  seen;
  idRecepit;
  idMessagePecgw;
  version;
  idFolder;
  deleted;
  nextSdrDateInformation = {
    createTime: NextSDRDateTypes.ZonedDateTime,
    updateTime: NextSDRDateTypes.ZonedDateTime,
    receiveTime: NextSDRDateTypes.ZonedDateTime,
    receiveDateProvider: NextSDRDateTypes.ZonedDateTime
  };
  fk_idPec;
  fk_idRelated;
  fk_messageAddressList;
  fk_messageTagList;
  fk_messageFolderList;
  fk_idRelatedList;
  fk_noteList;
  messageAddressList;
  messageTagList;
  messageFolderList;
  idRelatedList;
  noteList;
}
class MessageWithTagView {
  id;
  uuidMessage;
  idPec;
  idApplicazione;
  idRelated;
  subject;
  messageStatus;
  inOut;
  createTime;
  updateTime;
  receiveDateProvider;
  messageType;
  isPec;
  attachmentsNumber;
  uuidRepository;
  pathRepository;
  name;
  receiveTime;
  seen;
  idRecepit;
  idMessagePecgw;
  version;
  idTag;
  nextSdrDateInformation = {
    createTime: NextSDRDateTypes.ZonedDateTime,
    updateTime: NextSDRDateTypes.ZonedDateTime,
    receiveTime: NextSDRDateTypes.ZonedDateTime,
    receiveDateProvider: NextSDRDateTypes.ZonedDateTime
  };
  fk_idPec;
  fk_idRelated;
  fk_messageAddressList;
  fk_messageTagList;
  fk_messageFolderList;
  fk_idRelatedList;
  fk_noteList;
  messageAddressList;
  messageTagList;
  messageFolderList;
  idRelatedList;
  noteList;
}
class ContattiConflittuali {
  id;
  idContatti;
  motivazione;
  version;
  nextSdrDateInformation = {};
  fk_idContatti;
}
var MotivazioneConflitto;
(function (MotivazioneConflitto) {
  MotivazioneConflitto["CONTATTO_DUPLICATO"] = "CONTATTO_DUPLICATO";
})(MotivazioneConflitto || (MotivazioneConflitto = {}));
class Contatto {
  id;
  descrizione;
  cognome;
  nome;
  titolo;
  codiceFiscale;
  ragioneSociale;
  partitaIva;
  tipo;
  categoria;
  idUtenteCreazione;
  idPersonaCreazione;
  idAziende;
  idEsterno;
  provenienza;
  daVerificare;
  protocontatto;
  modificabile;
  eliminato;
  riservato;
  contattoErrato;
  contattiConDomiciliDigitaliModificati;
  tscol;
  ranking;
  version;
  nextSdrDateInformation = {};
  contattiFigliList;
  idContattoPadre;
  gruppiDelContattoList;
  contattiDelGruppoList;
  contattiDelGruppoListTransient;
  telefonoList;
  emailList;
  indirizziList;
  idStruttura;
  idPersona;
  dettaglioContattoList;
  permessiContatto;
  fk_idContattoPadre;
  fk_idPersonaCreazione;
  fk_idUtenteCreazione;
  fk_contattiFigliList;
  fk_gruppiDelContattoList;
  fk_contattiDelGruppoList;
  fk_telefonoList;
  fk_emailList;
  fk_indirizziList;
  fk_idStruttura;
  fk_idPersona;
  fk_dettaglioContattoList;
}
var CategoriaContatto;
(function (CategoriaContatto) {
  CategoriaContatto["PERSONA"] = "PERSONA";
  CategoriaContatto["STRUTTURA"] = "STRUTTURA";
  CategoriaContatto["ESTERNO"] = "ESTERNO";
  CategoriaContatto["GRUPPO"] = "GRUPPO";
})(CategoriaContatto || (CategoriaContatto = {}));
var TipoContatto;
(function (TipoContatto) {
  TipoContatto["ORGANIGRAMMA"] = "ORGANIGRAMMA";
  TipoContatto["PERSONA_FISICA"] = "PERSONA_FISICA";
  TipoContatto["AZIENDA"] = "AZIENDA";
  TipoContatto["PUBBLICA_AMMINISTRAZIONE_ITALIANA"] = "PUBBLICA_AMMINISTRAZIONE_ITALIANA";
  TipoContatto["PUBBLICA_AMMINISTRAZIONE_ESTERA"] = "PUBBLICA_AMMINISTRAZIONE_ESTERA";
  TipoContatto["VARIO"] = "VARIO";
  TipoContatto["FORNITORE"] = "FORNITORE";
})(TipoContatto || (TipoContatto = {}));
class ContattoConDettaglioPrincipale {
  id;
  descrizione;
  cognome;
  nome;
  titolo;
  codiceFiscale;
  ragioneSociale;
  partitaIva;
  tipo;
  categoria;
  idUtenteCreazione;
  idPersonaCreazione;
  idAziende;
  idEsterno;
  provenienza;
  daVerificare;
  protocontatto;
  modificabile;
  eliminato;
  riservato;
  contattoErrato;
  tscol;
  ranking;
  version;
  idDettaglio;
  dettaglioDescrizione;
  eliminatoDettaglio;
  principaleDettaglio;
  tipoDettaglio;
  tscolDettaglio;
  versionDettaglio;
  idContattoEsternoDettaglio;
  domicilioDigitale;
  nextSdrDateInformation = {};
  contattiFigliList;
  idContattoPadre;
  gruppiDelContattoList;
  contattiDelGruppoList;
  contattiDelGruppoListTransient;
  telefonoList;
  emailList;
  indirizziList;
  idStruttura;
  idPersona;
  dettaglioContattoList;
  permessiContatto;
  fk_idContattoPadre;
  fk_idPersonaCreazione;
  fk_idUtenteCreazione;
  fk_contattiFigliList;
  fk_gruppiDelContattoList;
  fk_contattiDelGruppoList;
  fk_telefonoList;
  fk_emailList;
  fk_indirizziList;
  fk_idStruttura;
  fk_idPersona;
  fk_dettaglioContattoList;
}
class GruppoCSV extends Contatto {
  contattiContenuti;
  nextSdrDateInformation = {};
}
class DettaglioContatto {
  id;
  principale;
  descrizione;
  version;
  idContatto;
  tipo;
  eliminato;
  domicilioDigitale;
  tscol;
  nextSdrDateInformation = {};
  telefono;
  email;
  indirizzo;
  gruppiDelDettaglioList;
  utenteStruttura;
  fk_idContatto;
  fk_gruppiDelDettaglioList;
  fk_telefonoList;
  fk_emailList;
  fk_indirizziList;
  // serve solo per destinatario estemporaneo
  mezzo;
}
var TipoDettaglio;
(function (TipoDettaglio) {
  TipoDettaglio["UTENTE_STRUTTURA"] = "UTENTE_STRUTTURA";
  TipoDettaglio["STRUTTURA"] = "STRUTTURA";
  TipoDettaglio["EMAIL"] = "EMAIL";
  TipoDettaglio["TELEFONO"] = "TELEFONO";
  TipoDettaglio["INDIRIZZO_FISICO"] = "INDIRIZZO_FISICO";
})(TipoDettaglio || (TipoDettaglio = {}));
class Email {
  id;
  email;
  tipo;
  principale;
  descrizione;
  provenienza;
  pec;
  version;
  idContatto;
  idDettaglioContatto;
  nextSdrDateInformation = {};
  fk_idDettaglioContatto;
  fk_idContatto;
}
class GruppiContatti {
  id;
  version;
  idContatto;
  idGruppo;
  idDettaglioContatto;
  nextSdrDateInformation = {};
  fk_idDettaglioContatto;
}
class Indirizzo {
  id;
  descrizione;
  cap;
  via;
  civico;
  comune;
  provincia;
  nazione;
  tipo;
  principale;
  provenienza;
  version;
  idContatto;
  idDettaglioContatto;
  nextSdrDateInformation = {};
  fk_idDettaglioContatto;
  fk_idContatto;
}
class Telefono {
  id;
  numero;
  tipo;
  principale;
  descrizione;
  fax;
  provenienza;
  version;
  idContatto;
  idDettaglioContatto;
  nextSdrDateInformation = {};
  fk_idDettaglioContatto;
  fk_idContatto;
}
class SqlSimilarityResults {
  emailList;
  indirizzo;
  codiceFiscale;
  cognomeAndNome;
  partitaIva;
  nextSdrDateInformation = {};
}
class SqlSimilarityContact {
  id;
  nome;
  cognome;
  categoria;
  descrizione;
  partitaIva;
  codiceFiscale;
  email;
  descrizioneIndirizzo;
  nextSdrDateInformation = {};
}
class SqlSimilarityResult {
  field;
  contact;
  similarity;
  distanceLev;
  idContact;
  foundValue;
  nextSdrDateInformation = {};
}
class Allegato {
  id;
  idDoc;
  idAllegatoPadre;
  allegatiFigliList;
  //dettagliAllegatiList: DettaglioAllegato[];
  nome;
  tipo;
  sottotipo;
  principale;
  ordinale;
  firmato;
  estraibile;
  dataInserimento;
  dataCreazione;
  versamentiAllegatiList;
  version;
  dettagli;
  // Creato con projection custom
  versamentoAllegato;
  nextSdrDateInformation = {
    dataCreazione: NextSDRDateTypes.ZonedDateTime,
    dataInserimento: NextSDRDateTypes.ZonedDateTime
  };
}
var TipoAllegato;
(function (TipoAllegato) {
  TipoAllegato["ALLEGATO"] = "ALLEGATO";
  TipoAllegato["LETTERA"] = "LETTERA";
  TipoAllegato["FRONTESPIZIO"] = "FRONTESPIZIO";
  TipoAllegato["STAMPA_UNICA"] = "STAMPA_UNICA";
  TipoAllegato["FASCICOLATO"] = "FASCICOLATO";
  TipoAllegato["STAMPA_UNICA_OMISSIS"] = "STAMPA_UNICA_OMISSIS";
  TipoAllegato["LETTERA_OMISSIS"] = "LETTERA_OMISSIS";
})(TipoAllegato || (TipoAllegato = {}));
var SottotipoAllegato;
(function (SottotipoAllegato) {
  SottotipoAllegato["LEGGE190"] = "LEGGE190";
})(SottotipoAllegato || (SottotipoAllegato = {}));
var TipoDettaglioAllegato;
(function (TipoDettaglioAllegato) {
  TipoDettaglioAllegato["ORIGINALE"] = "ORIGINALE";
  TipoDettaglioAllegato["CONVERTITO"] = "CONVERTITO";
  TipoDettaglioAllegato["SEGNAPOSTO"] = "SEGNAPOSTO";
  TipoDettaglioAllegato["ORIGINALE_FIRMATO"] = "ORIGINALE_FIRMATO";
  TipoDettaglioAllegato["ORIGINALE_FIRMATO_P7M"] = "ORIGINALE_FIRMATO_P7M";
  TipoDettaglioAllegato["CONVERTITO_FIRMATO"] = "CONVERTITO_FIRMATO";
  TipoDettaglioAllegato["CONVERTITO_FIRMATO_P7M"] = "CONVERTITO_FIRMATO_P7M";
})(TipoDettaglioAllegato || (TipoDettaglioAllegato = {}));
var TipoDettaglioAllegatoKeys;
(function (TipoDettaglioAllegatoKeys) {
  TipoDettaglioAllegatoKeys["originale"] = "originale";
  TipoDettaglioAllegatoKeys["convertito"] = "convertito";
  TipoDettaglioAllegatoKeys["segnaposto"] = "segnaposto";
  TipoDettaglioAllegatoKeys["originaleFirmato"] = "originaleFirmato";
  TipoDettaglioAllegatoKeys["convertitoFirmato"] = "convertitoFirmato";
  TipoDettaglioAllegatoKeys["originaleFirmatoP7m"] = "originaleFirmatoP7m";
  TipoDettaglioAllegatoKeys["convertitoFirmatoP7m"] = "convertitoFirmatoP7m";
})(TipoDettaglioAllegatoKeys || (TipoDettaglioAllegatoKeys = {}));
class DettaglioAllegato {
  idRepository;
  nome;
  estensione;
  dimensioneByte;
  mimeType;
  hashMd5;
  hashSha256;
  dataCreazione;
}
class Archivio {
  id;
  idAzienda;
  idArchivioPadre;
  archiviFigliList;
  idArchivioRadice;
  stato;
  livello;
  numero;
  anno;
  foglia;
  dataCreazione;
  idArchivioPrecedente;
  idTitolo;
  idMassimario;
  idArchivioArgo;
  tipo;
  oggetto;
  dataInserimentoRiga;
  version;
  isArchivioNero;
  numerazioneGerarchica;
  attoriList;
  riservato;
  permessi;
  note;
  anniTenuta;
  numeroSottoarchivi;
  permessiEspliciti;
  pregresso;
  fk_idAzienda;
  fk_idArchivioPrecedente;
  fk_idArchivioPadre;
  fk_idArchivioRadice;
  fk_idTitolo;
  fk_idMassimario;
  nextSdrDateInformation = {
    dataCreazione: NextSDRDateTypes.ZonedDateTime,
    dataInserimentoRiga: NextSDRDateTypes.ZonedDateTime
  };
}
var TipoArchivio;
(function (TipoArchivio) {
  TipoArchivio["AFFARE"] = "AFFARE";
  TipoArchivio["PROCEDIMENTO"] = "PROCEDIMENTO";
  TipoArchivio["ATTIVITA"] = "ATTIVITA";
  TipoArchivio["SOGGETTO_FISICO"] = "SOGGETTO_FISICO";
  TipoArchivio["SOGGETTO_GIURIDICO"] = "SOGGETTO_GIURIDICO";
  TipoArchivio["SPECIALE"] = "SPECIALE";
})(TipoArchivio || (TipoArchivio = {}));
var StatoArchivio;
(function (StatoArchivio) {
  StatoArchivio["BOZZA"] = "BOZZA";
  StatoArchivio["APERTO"] = "APERTO";
  StatoArchivio["PRECHIUSO"] = "PRECHIUSO";
  StatoArchivio["CHIUSO"] = "CHIUSO";
})(StatoArchivio || (StatoArchivio = {}));
class ArchivioDiInteresse {
  id;
  idPersona;
  idArchiviPreferiti;
  idArchiviRecenti;
  idArchiviFrequenti;
  dataInserimentoRiga;
  version;
  fk_idPersona;
  nextSdrDateInformation = {
    dataInserimentoRiga: NextSDRDateTypes.ZonedDateTime
  };
}
class ArchivioRecente {
  id;
  idArchivio;
  idPersona;
  dataRecentezza;
  version;
  fk_idPersona;
  fk_idArchivio;
  nextSdrDateInformation = {
    dataRecentezza: NextSDRDateTypes.ZonedDateTime
  };
}
class ArchivioDetail {
  id;
  idAzienda;
  idArchivioPadre;
  dataCreazionePadre;
  archiviFigliList;
  idArchivioRadice;
  dataCreazioneRadice;
  stato;
  livello;
  numero;
  anno;
  anniTenuta;
  foglia;
  permessi;
  numerazioneGerarchica;
  dataCreazione;
  idPersonaResponsabile;
  idPersonaCreazione;
  idStruttura;
  idTitolo;
  idMassimario;
  tipo;
  oggetto;
  oggettoTscol;
  rankingOggetto;
  tscol;
  isArchivioNero;
  ranking;
  dataInserimentoRiga;
  idVicari;
  descrizionePersonaVicarioList;
  version;
  riservato;
  numeroSottoarchivi;
  pregresso;
  bitAnomalie;
  fk_idAzienda;
  fk_idPersonaResponsabile;
  fk_idPersonaCreazione;
  fk_idStruttura;
  fk_idArchivioPadre;
  fk_idArchivioRadice;
  fk_idTitolo;
  fk_idMassimario;
  nextSdrDateInformation = {
    dataCreazione: NextSDRDateTypes.ZonedDateTime,
    dataCreazionePadre: NextSDRDateTypes.ZonedDateTime,
    dataCreazioneRadice: NextSDRDateTypes.ZonedDateTime,
    dataInserimentoRiga: NextSDRDateTypes.ZonedDateTime
  };
}
var AnomaliaArchivioDetail;
(function (AnomaliaArchivioDetail) {
  AnomaliaArchivioDetail["RESPONSABILE_DISATTIVO"] = "RESPONSABILE_DISATTIVO";
  AnomaliaArchivioDetail["VICARI_ATTIVI_NON_PRESENTI"] = "VICARI_ATTIVI_NON_PRESENTI";
  AnomaliaArchivioDetail["INCOERENZA_STRUTTURA"] = "INCOERENZA_STRUTTURA";
  AnomaliaArchivioDetail["CHIUSI_INVISIBILI"] = "CHIUSI_INVISIBILI";
})(AnomaliaArchivioDetail || (AnomaliaArchivioDetail = {}));
var DecimaleAnomaliaArchivioDetail;
(function (DecimaleAnomaliaArchivioDetail) {
  DecimaleAnomaliaArchivioDetail[DecimaleAnomaliaArchivioDetail["RESPONSABILE_DISATTIVO"] = 1] = "RESPONSABILE_DISATTIVO";
  DecimaleAnomaliaArchivioDetail[DecimaleAnomaliaArchivioDetail["VICARI_ATTIVI_NON_PRESENTI"] = 2] = "VICARI_ATTIVI_NON_PRESENTI";
  DecimaleAnomaliaArchivioDetail[DecimaleAnomaliaArchivioDetail["INCOERENZA_STRUTTURA"] = 4] = "INCOERENZA_STRUTTURA";
  DecimaleAnomaliaArchivioDetail[DecimaleAnomaliaArchivioDetail["CHIUSI_INVISIBILI"] = 8] = "CHIUSI_INVISIBILI";
})(DecimaleAnomaliaArchivioDetail || (DecimaleAnomaliaArchivioDetail = {}));
class ArchivioDoc {
  id;
  idArchivio;
  idDoc;
  idPersonaArchiviazione;
  dataArchiviazione;
  idPersonaEliminazione;
  dataEliminazione;
  dataInserimentoRiga;
  version;
  fk_idArchivio;
  fk_idDoc;
  fk_idPersonaArchiviazione;
  fk_idPersonaEliminazione;
  nextSdrDateInformation = {
    dataArchiviazione: NextSDRDateTypes.ZonedDateTime,
    dataEliminazione: NextSDRDateTypes.ZonedDateTime,
    dataInserimentoRiga: NextSDRDateTypes.ZonedDateTime
  };
}
class AttoreArchivio {
  id;
  idArchivio;
  idPersona;
  idStruttura;
  ruolo;
  dataInserimentoRiga;
  version;
  fk_idArchivio;
  fk_idPersona;
  fk_idStruttura;
  nextSdrDateInformation = {
    dataInserimentoRiga: NextSDRDateTypes.ZonedDateTime
  };
}
var RuoloAttoreArchivio;
(function (RuoloAttoreArchivio) {
  RuoloAttoreArchivio["RESPONSABILE"] = "RESPONSABILE";
  RuoloAttoreArchivio["CREATORE"] = "CREATORE";
  RuoloAttoreArchivio["VICARIO"] = "VICARIO";
  RuoloAttoreArchivio["RESPONSABILE_PROPOSTO"] = "RESPONSABILE_PROPOSTO";
})(RuoloAttoreArchivio || (RuoloAttoreArchivio = {}));
class AttoreDoc {
  id;
  idDoc;
  idPersona;
  idStruttura;
  ruolo;
  sullaScrivania;
  ordinale;
  dataInserimentoRiga;
  version;
  fk_idPersona;
  fk_idDoc;
  fk_idStruttura;
  nextSdrDateInformation = {
    dataInserimentoRiga: NextSDRDateTypes.ZonedDateTime
  };
}
var RuoloAttoreDoc;
(function (RuoloAttoreDoc) {
  RuoloAttoreDoc["REDATTORE"] = "REDATTORE";
  RuoloAttoreDoc["REDAZIONE"] = "REDAZIONE";
  RuoloAttoreDoc["CONTROLLO_SEGRETERIA"] = "CONTROLLO_SEGRETERIA";
  RuoloAttoreDoc["PARERATORE"] = "PARERATORE";
  RuoloAttoreDoc["VISTATORE"] = "VISTATORE";
  RuoloAttoreDoc["FIRMATARIO"] = "FIRMATARIO";
  RuoloAttoreDoc["FIRMA"] = "FIRMA";
  RuoloAttoreDoc["RESPONSABILE_PROCEDIMENTO"] = "RESPONSABILE_PROCEDIMENTO";
  RuoloAttoreDoc["DA"] = "DA";
  RuoloAttoreDoc["DS"] = "DS";
  RuoloAttoreDoc["DSC"] = "DSC";
  RuoloAttoreDoc["DG"] = "DG";
  RuoloAttoreDoc["RESCRITTO"] = "RESCRITTO";
  RuoloAttoreDoc["SEGRETERIA"] = "SEGRETERIA";
  RuoloAttoreDoc["ASSEGNATARIO"] = "ASSEGNATARIO";
  RuoloAttoreDoc["SPEDIZIONE_MANUALE"] = "SPEDIZIONE_MANUALE";
  RuoloAttoreDoc["RICEZIONE"] = "RICEZIONE";
})(RuoloAttoreDoc || (RuoloAttoreDoc = {}));
class CollegioSindacale {
  id;
  email;
  idAzienda;
  attivo;
  predefinita;
  version;
  nextSdrDateInformation = {};
}
class CollegioSindacaleDoc {
  id;
  idDoc;
  idCollegioSindacale;
  nextSdrDateInformation = {};
}
class DocDoc {
  id;
  idDocSorgente;
  idDocDestinazione;
  tipoCollegamento;
  idPersonaCollegante;
  dataInserimentoRiga;
  fk_idDocSorgente;
  fk_idDocDestinazione;
  fk_idPersonaCollegante;
  version;
  nextSdrDateInformation = {
    dataCreazione: NextSDRDateTypes.ZonedDateTime
  };
}
var TipoCollegamentoDoc;
(function (TipoCollegamentoDoc) {
  TipoCollegamentoDoc["PRECEDENTE"] = "PRECEDENTE";
  TipoCollegamentoDoc["MONITORAGGIO"] = "MONITORAGGIO";
})(TipoCollegamentoDoc || (TipoCollegamentoDoc = {}));
class Doc {
  id;
  additionalData;
  allegati;
  archiviDocList;
  attoriList;
  coinvolti;
  competenti;
  dataCreazione;
  firmatari;
  idAzienda;
  idEsterno;
  idPersonaCreazione;
  mittenti;
  oggetto;
  pareratori;
  pregresso;
  registroDocList;
  noteVersamentoList;
  related;
  statoVersamento;
  docAnnullatoList;
  idPecMittente;
  _tipologia;
  _visibilita;
  vistatori;
  note;
  annullato;
  notaAnnullamento;
  notaDocumento;
  notaVersamento;
  notaFlusso;
  dataUltimoVersamento;
  lottiList;
  docsCollegati;
  fk_allegati;
  fk_archiviDocList;
  fk_attori;
  fk_coinvolti;
  fk_competenti;
  fk_idAzienda;
  fk_idPersonaCreazione;
  fk_messageDocList;
  fk_mittenti;
  fk_registroDocList;
  fk_related;
  fk_versamentiList;
  fk_lottiList;
  version;
  nextSdrDateInformation = {
    dataCreazione: NextSDRDateTypes.ZonedDateTime
  };
  get tipologia() {
    return this._tipologia;
  }
  set tipologia(value) {
    this._tipologia = TipologiaDoc[value];
  }
  get visibilita() {
    return this._visibilita;
  }
  set visibilita(value) {
    this._visibilita = VisibilitaDoc[value];
  }
}
var VisibilitaDoc;
(function (VisibilitaDoc) {
  VisibilitaDoc["NORMALE"] = "NORMALE";
  VisibilitaDoc["LIMITATA"] = "LIMITATA";
  VisibilitaDoc["RISERVATO"] = "RISERVATO";
})(VisibilitaDoc || (VisibilitaDoc = {}));
var TipologiaDoc;
(function (TipologiaDoc) {
  TipologiaDoc["PROTOCOLLO_IN_USCITA"] = "PROTOCOLLO_IN_USCITA";
  TipologiaDoc["PROTOCOLLO_IN_ENTRATA"] = "PROTOCOLLO_IN_ENTRATA";
  TipologiaDoc["DETERMINA"] = "DETERMINA";
  TipologiaDoc["DELIBERA"] = "DELIBERA";
  TipologiaDoc["DOCUMENT_PEC"] = "DOCUMENT_PEC";
  TipologiaDoc["DOCUMENT_REGISTRO"] = "DOCUMENT_REGISTRO";
  TipologiaDoc["DOCUMENT_UTENTE"] = "DOCUMENT_UTENTE";
  TipologiaDoc["RGPICO"] = "RGPICO";
  TipologiaDoc["RGDETE"] = "RGDETE";
  TipologiaDoc["RGDELI"] = "RGDELI";
  TipologiaDoc["RACCOLTA_SEMPLICE"] = "RACCOLTA_SEMPLICE";
})(TipologiaDoc || (TipologiaDoc = {}));
var StatoDoc;
(function (StatoDoc) {
  StatoDoc["REDAZIONE"] = "REDAZIONE";
  StatoDoc["CLASSIFICAZIONE"] = "CLASSIFICAZIONE";
  StatoDoc["PARERE"] = "PARERE";
  StatoDoc["VISTA"] = "VISTA";
  StatoDoc["FIRMA"] = "FIRMA";
  StatoDoc["UFFICIO_ATTI"] = "UFFICIO_ATTI";
  StatoDoc["DG"] = "DG";
  StatoDoc["DS"] = "DS";
  StatoDoc["DA"] = "DA";
  StatoDoc["DSC"] = "DSC";
  StatoDoc["SMISTAMENTO"] = "SMISTAMENTO";
  StatoDoc["SPEDIZIONE"] = "SPEDIZIONE";
  StatoDoc["FINE"] = "FINE";
  StatoDoc["NUMERAZIONE"] = "NUMERAZIONE";
  StatoDoc["REGISTRAZIONE_PROTOCOLLO"] = "REGISTRAZIONE_PROTOCOLLO";
  StatoDoc["AVVIA_SPEDIZIONI"] = "AVVIA_SPEDIZIONI";
  StatoDoc["ASPETTA_SPEDIZIONI"] = "ASPETTA_SPEDIZIONI";
  StatoDoc["ATTENDI_JOBS"] = "ATTENDI_JOBS";
  StatoDoc["CONTROLLO_SEGRETERIA"] = "CONTROLLO_SEGRETERIA";
  StatoDoc["SPEDIZIONE_MANUALE"] = "SPEDIZIONE_MANUALE";
  StatoDoc["APPROVAZIONE"] = "APPROVAZIONE";
  StatoDoc["ANNULLATO"] = "ANNULLATO";
})(StatoDoc || (StatoDoc = {}));
class DocDetail {
  id;
  dataDocumento;
  idAzienda;
  idEsterno;
  tipologia;
  openCommand;
  commandType;
  idApplicazione;
  idPersonaResponsabileProcedimento;
  idPersonaRedattrice;
  dataCreazione;
  numeroProposta;
  annoProposta;
  idStrutturaRegistrazione;
  dataRegistrazione;
  numeroRegistrazione;
  annoRegistrazione;
  dataPubblicazione;
  oggetto;
  oggettoTscol;
  rankingOggetto;
  destinatari;
  destinatariTscol;
  rankingDestinatari;
  stato;
  visibilita;
  annullato;
  protocolloEsterno;
  mittente;
  mittenteTscol;
  rankingMittente;
  idContattoMittente;
  idMezzoRicezione;
  idPecMittente;
  statoUfficioAtti;
  idStruttureSegreteria;
  sullaScrivaniaDi;
  firmatari;
  idArchiviAntenati;
  idArchivi;
  statoUltimoVersamento;
  statoVersamentoVisto;
  dataUltimoVersamento;
  versamentoForzabile;
  versamentoForzabileConcordato;
  pregresso;
  collegiSindacali;
  tscol;
  ranking;
  testoTscol;
  idFirmatarioAttuale;
  codiceRegistro;
  permessiDocList;
  archiviDocList;
  // transient
  urlComplete;
  fk_idAzienda;
  fk_idPersonaResponsabileProcedimento;
  fk_idPersonaRedattrice;
  fk_idStrutturaRegistrazione;
  fk_idMezzoRicezione;
  fk_idAppicazione;
  fk_idFirmatario;
  nextSdrDateInformation = {
    dataDocumento: NextSDRDateTypes.ZonedDateTime,
    dataCreazione: NextSDRDateTypes.ZonedDateTime,
    dataRegistrazione: NextSDRDateTypes.ZonedDateTime,
    dataPubblicazione: NextSDRDateTypes.ZonedDateTime
  };
}
var CommandTypeDoc;
(function (CommandTypeDoc) {
  CommandTypeDoc["ROUTING"] = "ROUTING";
  CommandTypeDoc["COMPONENT"] = "COMPONENT";
  CommandTypeDoc["URL"] = "URL";
})(CommandTypeDoc || (CommandTypeDoc = {}));
var StatoUfficioAtti;
(function (StatoUfficioAtti) {
  StatoUfficioAtti["SOSPESA"] = "SOSPESA";
  StatoUfficioAtti["ELABORATA"] = "ELABORATA";
  StatoUfficioAtti["DA_VALUTARE"] = "DA_VALUTARE";
  StatoUfficioAtti["NON_RILEVANTE"] = "NON_RILEVANTE";
})(StatoUfficioAtti || (StatoUfficioAtti = {}));
class FirmatarioObject {
  idPersona;
  descrizione;
}
class Destinatario {
  nome;
  indirizzo;
  tipo;
}
class PersonaUsante {
  idPersona;
  descrizione;
}
class CollegioSindacaleDetail {
  idCollegioSindacale;
  email;
}
/* export enum StatiVersamento {
  IN_CARICO = "IN_CARICO",
  FORZARE = "FORZARE",
  VERSARE = "VERSARE",
  AGGIORNARE = "AGGIORNARE",
  PARZIALE = "PARZIALE",
  VERSATO = "VERSATO",
  ANNULLATO = "ANNULLATO",
  IN_CARICO_CON_ERRORI = "IN_CARICO_CON_ERRORI",
  IN_CARICO_CON_ERRORI_RITENTABILI = "IN_CARICO_CON_ERRORI_RITENTABILI",
  ERRORE = "ERRORE",
  ERRORE_RITENTABILE = "ERRORE_RITENTABILE"
} */
/* export class Fascicolazione {
  nome: string;
  numerazione: string;
  idFascicoloArgo: string;
  idFascicoloRadiceArgo: string;
}

export class Classificazione {
  nome: string;
  numerazione: string;
} */
/* export class PersonaVedente implements JsonField {
  idPersona: number;
  mioDocumento: boolean;
  pienaVisibilita: boolean;
  modalitaApertura: string;
} */

class PermessoArchivio {
  id;
  idPersona;
  idArchivioDetail;
  idAzienda;
  dataCreazione;
  version;
  bit;
  fk_idPersona;
  fk_idAzienda;
  fk_idArchivioDetail;
  nextSdrDateInformation = {
    dataCreazione: NextSDRDateTypes.ZonedDateTime
  };
}
var DecimalePredicato;
(function (DecimalePredicato) {
  DecimalePredicato[DecimalePredicato["PASSAGGIO"] = 1] = "PASSAGGIO";
  DecimalePredicato[DecimalePredicato["VISUALIZZA"] = 2] = "VISUALIZZA";
  DecimalePredicato[DecimalePredicato["MODIFICA"] = 4] = "MODIFICA";
  DecimalePredicato[DecimalePredicato["ELIMINA"] = 8] = "ELIMINA";
  DecimalePredicato[DecimalePredicato["VICARIO"] = 16] = "VICARIO";
  DecimalePredicato[DecimalePredicato["RESPONSABILE_PROPOSTO"] = 32] = "RESPONSABILE_PROPOSTO";
  DecimalePredicato[DecimalePredicato["RESPONSABILE"] = 64] = "RESPONSABILE";
})(DecimalePredicato || (DecimalePredicato = {}));
/* export enum TipoSoggettoPermessoArchivio {
  PERSONA = "PERSONA",
  STRUTTURA = "STRUTTURA"
} */

class PermessoDoc {
  id;
  idDocDetail;
  idPersona;
  bitVisibilita;
  dataDocumento;
  idAzienda;
  fk_idPersona;
  fk_idDocDetail;
  fk_idAzienda;
  nextSdrDateInformation = {
    dataDocumento: NextSDRDateTypes.ZonedDateTime
  };
}
var DecimaleAttributoVisibilita;
(function (DecimaleAttributoVisibilita) {
  DecimaleAttributoVisibilita[DecimaleAttributoVisibilita["MIO_DOCUMENTO"] = 1] = "MIO_DOCUMENTO";
  DecimaleAttributoVisibilita[DecimaleAttributoVisibilita["PIENA_VISIBILITA"] = 2] = "PIENA_VISIBILITA";
})(DecimaleAttributoVisibilita || (DecimaleAttributoVisibilita = {}));
class Registro {
  id;
  idAzienda;
  codice;
  ufficiale;
  attivo;
  version;
  nextSdrDateInformation = {};
  fk_idAzienda;
}
var CODICI_REGISTRO;
(function (CODICI_REGISTRO) {
  CODICI_REGISTRO["PG"] = "PG";
  CODICI_REGISTRO["DETE"] = "DETE";
  CODICI_REGISTRO["DELI"] = "DELI";
  CODICI_REGISTRO["RS"] = "RS";
  CODICI_REGISTRO["FASCICOLO"] = "FASCICOLO";
  CODICI_REGISTRO["PROP_PG"] = "PROP_PG";
  CODICI_REGISTRO["PROP_DETE"] = "PROP_DETE";
  CODICI_REGISTRO["PROP_DELI"] = "PROP_DELI";
  CODICI_REGISTRO["PROP_RS"] = "PROP_RS";
  CODICI_REGISTRO["GEDI"] = "GEDI";
  CODICI_REGISTRO["RGPICO"] = "RGPICO";
  CODICI_REGISTRO["RGDETE"] = "RGDETE";
  CODICI_REGISTRO["RGDELI"] = "RGDELI";
})(CODICI_REGISTRO || (CODICI_REGISTRO = {}));
class RegistroDoc {
  id;
  idDoc;
  idRegistro;
  numero;
  numeroVisualizzazione;
  anno;
  idPersonaRegistrante;
  idStrutturaRegistrante;
  dataRegistrazione;
  version;
  nextSdrDateInformation = {
    dataRegistrazione: NextSDRDateTypes.ZonedDateTime
  };
  fk_idDoc;
  fk_idRegistro;
}
class Mezzo {
  id;
  codice;
  descrizione;
  version;
  nextSdrDateInformation = {};
}
var CodiceMezzo;
(function (CodiceMezzo) {
  CodiceMezzo["PEC"] = "PEC";
  CodiceMezzo["BABEL"] = "BABEL";
  CodiceMezzo["MAIL"] = "MAIL";
  CodiceMezzo["POSTA_ORDINARIA"] = "POSTA_ORDINARIA";
  CodiceMezzo["FAX"] = "FAX";
  CodiceMezzo["RACCOMANDATA"] = "RACCOMANDATA";
  CodiceMezzo["TELEFONO"] = "TELEFONO";
})(CodiceMezzo || (CodiceMezzo = {}));
class Related {
  id;
  idDoc;
  idContatto;
  idPersonaInserente;
  tipo;
  descrizione;
  idGruppo;
  relatedList; //relatedList per il discorso dei gruppi (sono i figli del gruppo)
  spedizioneList;
  origine;
  dataInserimento;
  ultimaSpedizione;
  version;
  nextSdrDateInformation = {
    dataInserimento: NextSDRDateTypes.ZonedDateTime
  };
}
var TipoRelated;
(function (TipoRelated) {
  TipoRelated["A"] = "A";
  TipoRelated["CC"] = "CC";
  TipoRelated["MITTENTE"] = "MITTENTE";
})(TipoRelated || (TipoRelated = {}));
var OrigineRelated;
(function (OrigineRelated) {
  OrigineRelated["ESTERNO"] = "ESTERNO";
  OrigineRelated["INTERNO"] = "INTERNO";
  OrigineRelated["GRUPPO"] = "GRUPPO";
})(OrigineRelated || (OrigineRelated = {}));
class Spedizione {
  id;
  idRelated;
  idMessage;
  idMezzo;
  idSmistamento;
  idDettaglioContatto;
  indirizzo; // nel caso il mezzo sia pec e email sara valorizzato solo il campo "completo"
  annullata;
  data;
  dataInserimento;
  version;
  nextSdrDateInformation = {
    data: NextSDRDateTypes.ZonedDateTime,
    dataInserimento: NextSDRDateTypes.ZonedDateTime
  };
}
class IndirizzoSpedizione {
  completo;
  via;
  civico;
  comune;
  provincia;
  nazione;
  cap;
}
class Smistamento {
  id;
  idStruttuta;
  data_inserimento;
  version;
  nextSdrDateInformation = {
    data_inserimento: NextSDRDateTypes.ZonedDateTime
  };
}
class MassimarioOLD {
  id;
  nome;
  descrizioneTenuta;
  anniTenuta;
  dataInserimentoRiga;
  titoli;
  version;
  fk_idAzienda;
  idAzienda;
  nextSdrDateInformation = {
    dataInserimentoRiga: NextSDRDateTypes.ZonedDateTime
  };
}
class NoteVersamento {
  id;
  nota;
  dataInserimento;
  idPersona;
  fk_idPersona;
  fk_idDoc;
  idDoc;
  version;
  nextSdrDateInformation = {
    dataInserimento: NextSDRDateTypes.ZonedDateTime
  };
}
class TitoloOLD {
  id;
  nome;
  classificazione;
  dataInserimentoRiga;
  chiuso;
  fk_idAzienda;
  idAzienda;
  fk_idTitoloPadre;
  idTitoloPadre;
  massimario;
  version;
  livello;
  foglia;
  nextSdrDateInformation = {
    dataInserimentoRiga: NextSDRDateTypes.ZonedDateTime
  };
}
class Monitoraggio {
  id;
  idDoc;
  monitorato;
  completato;
  dataScadenza;
  dataCompletamento;
  dataInizioMonitoraggio;
  note;
  version;
  statusMonitoraggio;
  fk_idDoc;
  nextSdrDateInformation = {
    dataInizioMonitoraggio: NextSDRDateTypes.ZonedDateTime
  };
}
var StatusMonitoraggio;
(function (StatusMonitoraggio) {
  StatusMonitoraggio["COMPLETATO"] = "COMPLETATO";
  StatusMonitoraggio["IN_CORSO"] = "IN_CORSO";
  StatusMonitoraggio["SCADUTO"] = "SCADUTO";
})(StatusMonitoraggio || (StatusMonitoraggio = {}));
class Titolo {
  id;
  fk_idAzienda;
  fk_idTitoloPadre;
  fk_idVersione;
  fk_massimarioTitolo;
  idAzienda;
  idTitoloPadre;
  idVersione;
  idMassimarioTitolo;
  version;
  nome;
  classificazione;
  descrizione;
  note;
  dataInserimentoRiga;
  chiuso;
  livello;
  foglia;
  idEsterno;
  nextSdrDateInformation = {
    dataInserimentoRiga: NextSDRDateTypes.ZonedDateTime
  };
}
class Massimario {
  id;
  fk_idAzienda;
  fk_idMassimarioTitolo;
  idMassimarioTitolo;
  idAzienda;
  version;
  massimarioTitoliList;
  titoli;
  nome;
  descrizioneTenuta;
  anniTenuta;
  dataInserimentoRiga;
  dataInizio;
  dataFine;
  eliminato;
  nextSdrDateInformation = {
    dataInserimentoRiga: NextSDRDateTypes.ZonedDateTime,
    dataInizio: NextSDRDateTypes.ZonedDateTime,
    dataFine: NextSDRDateTypes.ZonedDateTime
  };
}
class ArchivioDetailView {
  id;
  idAzienda;
  idArchivioPadre;
  dataCreazionePadre;
  archiviFigliList;
  idArchivioRadice;
  dataCreazioneRadice;
  livello;
  stato;
  nome;
  numero;
  anno;
  foglia;
  numerazioneGerarchica;
  dataCreazione;
  idPersonaResponsabile;
  idPersonaCreazione;
  idStruttura;
  idTitolo;
  idMassimario;
  idVicari;
  descrizionePersonaVicarioList;
  tipo;
  oggetto;
  oggettoTscol;
  rankingOggetto;
  tscol;
  ranking;
  dataInserimentoRiga;
  version;
  idPersona;
  numeroSottoarchivi;
  conservazione;
  pregresso;
  bitAnomalie;
  fk_idAzienda;
  fk_idPersona;
  fk_idPersonaResponsabile;
  fk_idPersonaCreazione;
  fk_idStruttura;
  fk_idArchivioPadre;
  fk_idArchivioRadice;
  fk_idTitolo;
  fk_idMassimario;
  nextSdrDateInformation = {
    dataCreazione: NextSDRDateTypes.ZonedDateTime,
    dataCreazionePadre: NextSDRDateTypes.ZonedDateTime,
    dataCreazioneRadice: NextSDRDateTypes.ZonedDateTime,
    dataInserimentoRiga: NextSDRDateTypes.ZonedDateTime
  };
}
class DocDetailView {
  id;
  bitVisibilita;
  idPersona;
  dataDocumento;
  dataDocumentoDoc;
  idAzienda;
  idAziendaDoc;
  idEsterno;
  tipologia;
  openCommand;
  commandType;
  idApplicazione;
  monitoraggiList;
  idPersonaResponsabileProcedimento;
  idPersonaRedattrice;
  dataCreazione;
  numeroProposta;
  annoProposta;
  idStrutturaRegistrazione;
  dataRegistrazione;
  numeroRegistrazione;
  annoRegistrazione;
  dataPubblicazione;
  oggetto;
  oggettoTscol;
  rankingOggetto;
  destinatari;
  destinatariTscol;
  rankingDestinatari;
  stato;
  visibilita;
  annullato;
  protocolloEsterno;
  mittente;
  mittenteTscol;
  rankingMittente;
  idContattoMittente;
  idMezzoRicezione;
  idPecMittente;
  statoUfficioAtti;
  idStruttureSegreteria;
  sullaScrivaniaDi;
  firmatari;
  idArchiviAntenati;
  idArchivi;
  statoUltimoVersamento;
  statoVersamentoVisto;
  dataUltimoVersamento;
  versamentoForzabile;
  versamentoForzabileConcordato;
  pregresso;
  collegiSindacali;
  tscol;
  ranking;
  testoTscol;
  permessiDocList;
  archiviDocList;
  // transient
  urlComplete;
  fk_idPersona;
  fk_idAzienda;
  fk_idPersonaResponsabileProcedimento;
  fk_idPersonaRedattrice;
  fk_idStrutturaRegistrazione;
  fk_idMezzoRicezione;
  fk_idAppicazione;
  nextSdrDateInformation = {
    dataDocumento: NextSDRDateTypes.ZonedDateTime,
    dataCreazione: NextSDRDateTypes.ZonedDateTime,
    dataRegistrazione: NextSDRDateTypes.ZonedDateTime,
    dataPubblicazione: NextSDRDateTypes.ZonedDateTime
  };
}
class ProjectedDocDetail {
  id;
  dataDocumento;
  idAzienda;
  idEsterno;
  tipologia;
  openCommand;
  commandType;
  idApplicazione;
  idPersonaResponsabileProcedimento;
  idPersonaRedattrice;
  dataCreazione;
  numeroProposta;
  annoProposta;
  idStrutturaRegistrazione;
  dataRegistrazione;
  numeroRegistrazione;
  annoRegistrazione;
  dataPubblicazione;
  oggetto;
  oggettoTscol;
  rankingOggetto;
  destinatari;
  destinatariTscol;
  rankingDestinatari;
  stato;
  visibilita;
  annullato;
  protocolloEsterno;
  mittente;
  mittenteTscol;
  rankingMittente;
  idContattoMittente;
  idMezzoRicezione;
  idPecMittente;
  statoUfficioAtti;
  idStruttureSegreteria;
  sullaScrivaniaDi;
  firmatari;
  idArchiviAntenati;
  idArchivi;
  statoUltimoVersamento;
  statoVersamentoVisto;
  dataUltimoVersamento;
  versamentoForzabile;
  versamentoForzabileConcordato;
  pregresso;
  collegiSindacali;
  tscol;
  ranking;
  testoTscol;
  idFirmatarioAttuale;
  codiceRegistro;
  permessiDocList;
  archiviDocList;
  // transient
  urlComplete;
  fk_idAzienda;
  fk_idPersonaResponsabileProcedimento;
  fk_idPersonaRedattrice;
  fk_idStrutturaRegistrazione;
  fk_idMezzoRicezione;
  fk_idAppicazione;
  nextSdrDateInformation = {
    dataDocumento: NextSDRDateTypes.ZonedDateTime,
    dataCreazione: NextSDRDateTypes.ZonedDateTime,
    dataRegistrazione: NextSDRDateTypes.ZonedDateTime,
    dataPubblicazione: NextSDRDateTypes.ZonedDateTime
  };
}
class ProjectedDocDetailWithPermessoDoc {
  id;
  bitVisibilita;
  idPersona;
  dataDocumento;
  dataDocumentoDoc;
  idAzienda;
  idAziendaDoc;
  idEsterno;
  tipologia;
  openCommand;
  commandType;
  idApplicazione;
  idPersonaResponsabileProcedimento;
  idPersonaRedattrice;
  dataCreazione;
  numeroProposta;
  annoProposta;
  idStrutturaRegistrazione;
  dataRegistrazione;
  numeroRegistrazione;
  annoRegistrazione;
  dataPubblicazione;
  oggetto;
  oggettoTscol;
  rankingOggetto;
  destinatari;
  destinatariTscol;
  rankingDestinatari;
  stato;
  visibilita;
  annullato;
  protocolloEsterno;
  mittente;
  mittenteTscol;
  rankingMittente;
  idContattoMittente;
  idMezzoRicezione;
  idPecMittente;
  statoUfficioAtti;
  idStruttureSegreteria;
  sullaScrivaniaDi;
  firmatari;
  idArchiviAntenati;
  idArchivi;
  monitoraggiList;
  statoUltimoVersamento;
  statoVersamentoVisto;
  dataUltimoVersamento;
  versamentoForzabile;
  versamentoForzabileConcordato;
  pregresso;
  collegiSindacali;
  tscol;
  ranking;
  testoTscol;
  idFirmatarioAttuale;
  codiceRegistro;
  permessiDocList;
  archiviDocList;
  // transient
  urlComplete;
  fk_idPersona;
  fk_idAzienda;
  fk_idPersonaResponsabileProcedimento;
  fk_idPersonaRedattrice;
  fk_idStrutturaRegistrazione;
  fk_idMezzoRicezione;
  fk_idAppicazione;
  nextSdrDateInformation = {
    dataDocumento: NextSDRDateTypes.ZonedDateTime,
    dataCreazione: NextSDRDateTypes.ZonedDateTime,
    dataRegistrazione: NextSDRDateTypes.ZonedDateTime,
    dataPubblicazione: NextSDRDateTypes.ZonedDateTime
  };
}
class MassimarioTitolo {
  id;
  fk_idTitolo;
  fk_idMassimario;
  idTitolo;
  idMassimario;
  version;
  dataInizio;
  dataFine;
  eliminato;
  dataInserimentoRiga;
  nextSdrDateInformation = {
    dataInizio: NextSDRDateTypes.ZonedDateTime,
    dataFine: NextSDRDateTypes.ZonedDateTime
  };
}
class Versione {
  id;
  fk_idAzienda;
  idAzienda;
  version;
  stato;
  classificazione;
  dataInizio;
  dataFine;
  descrizione;
  note;
  nextSdrDateInformation = {
    dataInizio: NextSDRDateTypes.ZonedDateTime,
    dataFine: NextSDRDateTypes.ZonedDateTime
  };
}
class RegistroCreazione {
  id;
  fk_idTitoloSorgente;
  fk_idTitoloDestinazione;
  fk_idPersona;
  fk_idAzienda;
  idTitoloSorgente;
  idTitoloDestinazione;
  idPersona;
  idAzienda;
  idVersione;
  version;
  operazione;
  dataOra;
  nextSdrDateInformation = {
    dataOra: NextSDRDateTypes.ZonedDateTime
  };
}
var OperazioneRegistroCreazione;
(function (OperazioneRegistroCreazione) {
  OperazioneRegistroCreazione["CONVERGENZA"] = "CONVERGENZA";
  OperazioneRegistroCreazione["DIRAMAZIONE_PRINCIPALE"] = "DIRAMAZIONE_PRINCIPALE";
  OperazioneRegistroCreazione["DIRAMAZIONE_SECONDARIA"] = "DIRAMAZIONE_SECONDARIA";
  OperazioneRegistroCreazione["APERTURA"] = "APERTURA";
  OperazioneRegistroCreazione["CHIUSURA"] = "CHIUSURA";
})(OperazioneRegistroCreazione || (OperazioneRegistroCreazione = {}));
class Firmatario {
  id;
  idAttore;
  idPersona;
  idDoc;
  tsFirma;
  _stato;
  documentoVisto;
  _tipologiaFirma;
  metadatiFirma;
  _mezzoFirmaUsato;
  codiceVersione;
  fk_attore;
  fk_persona;
  fk_doc;
  nextSdrDateInformation = {
    tsFirma: NextSDRDateTypes.ZonedDateTime
  };
  get tipologiaFirma() {
    return this._tipologiaFirma;
  }
  set tipologiaFirma(value) {
    this._tipologiaFirma = TipologiaFirma[value];
  }
  get stato() {
    return this._stato;
  }
  set stato(value) {
    this._stato = StatiFirmatario[value];
  }
  get mezzoFirmaUsato() {
    return this._mezzoFirmaUsato;
  }
  set mezzoFirmaUsato(value) {
    this._mezzoFirmaUsato = TramiteFirma[value];
  }
}
var StatiFirmatario;
(function (StatiFirmatario) {
  StatiFirmatario["NON_IN_FIRMA"] = "NON_IN_FIRMA";
  StatiFirmatario["IN_FIRMA"] = "IN_FIRMA";
  StatiFirmatario["AGGIUNTO_AL_FIRMONE"] = "AGGIUNTO_AL_FIRMONE";
  StatiFirmatario["IN_LAVORAZIONE"] = "IN_LAVORAZIONE";
  StatiFirmatario["FIRMATO"] = "FIRMATO";
  StatiFirmatario["IN_ERRORE"] = "IN_ERRORE";
})(StatiFirmatario || (StatiFirmatario = {}));
var TipologiaFirma;
(function (TipologiaFirma) {
  TipologiaFirma["PADES"] = "PADES";
  TipologiaFirma["CADES"] = "CADES";
  TipologiaFirma["XADES"] = "XADES";
})(TipologiaFirma || (TipologiaFirma = {}));
class FirmatarioAllegato {
  id;
  idAllegato;
  idAttore;
  idPersonaInserente;
  tsFirma;
  _tipologiaFirma;
  metadatiFirma;
  _mezzoFirmaUsato;
  codiceVersione;
  dataInserimento;
  firmato;
  tipoDettaglioFirmato;
  fk_attore;
  fk_persona;
  fk_allegato;
  nextSdrDateInformation = {
    tsFirma: NextSDRDateTypes.ZonedDateTime,
    dataInserimento: NextSDRDateTypes.ZonedDateTime
  };
  get tipologiaFirma() {
    return this._tipologiaFirma;
  }
  set tipologiaFirma(value) {
    this._tipologiaFirma = TipologiaFirma[value];
  }
  get mezzoFirmaUsato() {
    return this._mezzoFirmaUsato;
  }
  set mezzoFirmaUsato(value) {
    this._mezzoFirmaUsato = TramiteFirma[value];
  }
}
class ImportazioneDocumento {
  id;
  idSessioneImportazione;
  registro;
  numero;
  anno;
  oggetto;
  dataRegistrazione;
  dataArrivo;
  dataAdozione;
  destinatariInterni;
  destinatariInterniA;
  destinatariInterniCc;
  indirizziDestinatariPrincipali;
  destinatariPrincipali;
  descrizioneIndirizziPrincipali;
  indirizziAltriDestinatari;
  altriDestinatari;
  descrizioneAltriIndirizzi;
  indirizziDestinatariEsterni;
  nomiDestinatariEsterni;
  adottatoDa;
  direttoreGenerale;
  vicarioDirettoreGenerale;
  direttoreSanitario;
  direttoreAmministrativo;
  direttoreScientifico;
  propostoDa;
  proponente;
  protocollatoDa;
  protocolloEsterno;
  dataProtocolloEsterno;
  pecMittente;
  indirizzoMittente;
  mittente;
  mezzo;
  firmatari;
  firmatario;
  pareri;
  redattore;
  visto;
  fascicolazione;
  classificazione;
  visibilitaLimitata;
  riservato;
  allegati;
  annotazioni;
  numeroPubblicazione;
  dataInizio;
  dataFine;
  annoPubblicazione;
  dataEsecutivita;
  controlloRegionale;
  conservato;
  collegamentoPrecedente;
  note;
  annullato;
  noteAnnullamento;
  dataAnnullamento;
  dataInvioConservazione;
  strutturaVisibilita;
  errori;
  idFascicoloPregresso;
  idRepoCsv;
  tscol;
  rankingTscol;
  stato;
  version;
  fk_idSessioneImportazione;
  nextSdrDateInformation = {};
}
var StatoImportazioneDocumento;
(function (StatoImportazioneDocumento) {
  StatoImportazioneDocumento["IMPORTARE"] = "IMPORTARE";
  StatoImportazioneDocumento["IMPORTATO"] = "IMPORTATO";
  StatoImportazioneDocumento["GIA_IMPORTATO"] = "GIA_IMPORTATO";
  StatoImportazioneDocumento["ERRORE_VALIDAZIONE"] = "ERRORE_VALIDAZIONE";
  StatoImportazioneDocumento["ERRORE_IMPORTAZIONE"] = "ERRORE_IMPORTAZIONE";
  StatoImportazioneDocumento["ANOMALIA_IMPORTAZIONE"] = "ANOMALIA_IMPORTAZIONE";
  StatoImportazioneDocumento["ANOMALIA_VALIDAZIONE"] = "ANOMALIA_VALIDAZIONE";
  StatoImportazioneDocumento["VALIDARE"] = "VALIDARE";
})(StatoImportazioneDocumento || (StatoImportazioneDocumento = {}));
class SessioneImportazione {
  id;
  nome;
  tipologia;
  idAzienda;
  idStrutturaDefault;
  idArchivioDefault;
  separatore;
  idPersonaVicarioDefault;
  idRepoCsv;
  importazioneDocumentoList;
  fk_idAzienda;
  fk_idStrutturaDefault;
  fk_idPersonaVicarioDefault;
  fk_idArchivioDefault;
  nextSdrDateInformation = {};
  version;
}
class DominioAruba {
  codice;
  nome;
}
const DominiAruba = {
  frAUSLBO: "frAUSLBO",
  frAUSLPR: "frAUSLPR",
  frAOPR: "frAOPR",
  frAslImola: "frAslImola",
  firma: "firma"
};
class Configuration {
  hostId;
  provider;
  internalCredentialsManager;
  params;
  descrizione;
}
class Provider {
  id;
  nome;
  descrizione;
}
class SupportedFile {
  id;
  mimeType;
  estensione;
  convertibilePdf;
  anteprimaOriginale;
  idAziende;
  note;
  nextSdrDateInformation = {};
}
class SessioneVersamento {
  id;
  tipologia;
  timeInterval;
  idArchivio;
  version;
  fk_idArchivio;
  nextSdrDateInformation = {
    // timeInterval: NextSDRDateTypes.ZonedDateTime
  };
}
var TipologiaSessioneVersamento;
(function (TipologiaSessioneVersamento) {
  TipologiaSessioneVersamento["FORZATURA"] = "FORZATURA";
  TipologiaSessioneVersamento["INVIO_GIORNALIERO"] = "INVIO_GIORNALIERO";
  TipologiaSessioneVersamento["CHIUSURA_FASCICOLO"] = "CHIUSURA_FASCICOLO";
})(TipologiaSessioneVersamento || (TipologiaSessioneVersamento = {}));
class Versamento {
  id;
  idDoc;
  idSessioneVersamento;
  data;
  stato;
  metadatiVersati;
  rapporto;
  codiceErrore;
  descrizioneErrore;
  idPersonaForzatura;
  dataForzatura;
  dataInserimento;
  version;
  idArchivio;
  ignora;
  idVersamentoRitentato;
  forzabile;
  forzabileConcordato;
  fk_idDoc;
  fk_idSessioneVersamento;
  fk_idPersonaForzatura;
  fk_idArchivio;
  fk_idVersamentoRitentato;
  nextSdrDateInformation = {
    data: NextSDRDateTypes.ZonedDateTime,
    dataForzatura: NextSDRDateTypes.ZonedDateTime,
    dataInserimento: NextSDRDateTypes.ZonedDateTime
  };
}
var StatoVersamento;
(function (StatoVersamento) {
  StatoVersamento["IN_CARICO"] = "IN_CARICO";
  StatoVersamento["FORZARE"] = "FORZARE";
  StatoVersamento["VERSARE"] = "VERSARE";
  StatoVersamento["AGGIORNARE"] = "AGGIORNARE";
  StatoVersamento["PARZIALE"] = "PARZIALE";
  StatoVersamento["VERSATO"] = "VERSATO";
  StatoVersamento["ANNULLATO"] = "ANNULLATO";
  StatoVersamento["IN_CARICO_CON_ERRORI"] = "IN_CARICO_CON_ERRORI";
  StatoVersamento["IN_CARICO_CON_ERRORI_RITENTABILI"] = "IN_CARICO_CON_ERRORI_RITENTABILI";
  StatoVersamento["ERRORE"] = "ERRORE";
  StatoVersamento["ERRORE_RITENTABILE"] = "ERRORE_RITENTABILE";
  StatoVersamento["VERSATO_CON_INTERVENTO_MANUALE"] = "VERSATO_CON_INTERVENTO_MANUALE";
})(StatoVersamento || (StatoVersamento = {}));
class VersamentoAllegato {
  id;
  idVersamento;
  idAllegato;
  stato;
  codiceErrore;
  descrizioneErrore;
  dataInserimento;
  version;
  nextSdrDateInformation = {
    dataInserimento: NextSDRDateTypes.ZonedDateTime
  };
}
class Contraente {
  id;
  nome;
  attivo;
  version;
  fk_LottiList;
  nextSdrDateInformation = {};
}
class Tipologia {
  id;
  nome;
  attivo;
  version;
  fk_LottiList;
  nextSdrDateInformation = {};
}
class RuoloComponente {
  id;
  nome;
  attivo;
  version;
  fk_ComponentiList;
  nextSdrDateInformation = {};
}
class Componente {
  id;
  codiceFiscale;
  ragioneSociale;
  idRuolo;
  version;
  combinedKey; // Property optional per combinare due campi ed avere una chiave unica
  fk_idRuolo;
  fk_idGruppo;
  nextSdrDateInformation = {};
}
class GruppoLotto {
  id;
  tipo;
  componentiList;
  version;
  fk_idLotto;
  fk_componentiList;
  nextSdrDateInformation = {};
}
var TipoGruppo;
(function (TipoGruppo) {
  TipoGruppo["PARTECIPANTE"] = "PARTECIPANTE";
  TipoGruppo["AGGIUDICATARIO"] = "AGGIUDICATARIO";
})(TipoGruppo || (TipoGruppo = {}));
class Lotto {
  id;
  cig;
  descrizioneLotto;
  idTipologia;
  oggetto;
  idContraente;
  importoTotale;
  importoLiquidato;
  dataInizio;
  dataCompletamento;
  idDoc;
  version;
  gruppiList;
  gruppiPartecipanti;
  gruppiAggiudicatari;
  fk_idTipologia;
  fk_idContraente;
  fk_gruppiList;
  fk_idDoc;
  nextSdrDateInformation = {
    dataInizio: NextSDRDateTypes.LocalDate,
    dataCompletamento: NextSDRDateTypes.LocalDate
  };
}
class Job {
  id;
  name;
  data;
  set;
  state;
  deferred;
  error;
  insertedFrom;
  hash;
  executableCheckEveryMillis;
  workData;
  insertTs;
  lastExecutionTs;
  fk_set;
  nextSdrDateInformation = {
    insertTs: NextSDRDateTypes.ZonedDateTime,
    lastExecutionTs: NextSDRDateTypes.ZonedDateTime
  };
}
var JobState;
(function (JobState) {
  JobState["READY"] = "READY";
  JobState["RUNNING"] = "RUNNING";
  JobState["ERROR"] = "ERROR";
  JobState["DONE"] = "DONE";
})(JobState || (JobState = {}));
class Set {
  id;
  nextSdrDateInformation = {};
}
var SetPriority;
(function (SetPriority) {
  SetPriority["NORMAL"] = "NORMAL";
  SetPriority["HIGH"] = "HIGH";
  SetPriority["HIGHEST"] = "HIGHEST";
})(SetPriority || (SetPriority = {}));
class PermessoEntitaStoredProcedure {
  soggetto;
  oggetto;
  categorie;
  derivati;
  nextSdrDateInformation = {};
}
class CategoriaPermessiStoredProcedure {
  ambito;
  tipo;
  permessi;
  nextSdrDateInformation = {};
}
class PermessoStoredProcedure {
  id;
  soggetto;
  oggetto;
  predicato;
  propaga_soggetto;
  propaga_oggetto;
  virtuale;
  virtuale_oggetto;
  data_inserimento_riga;
  data_ultima_modifica;
  origine_permesso;
  id_permesso_bloccato;
  permesso_bloccato;
  attivo_dal;
  attivo_al;
  entita_veicolante;
  nextSdrDateInformation = {
    attivo_al: NextSDRDateTypes.LocalDateTime,
    attivo_dal: NextSDRDateTypes.LocalDateTime,
    data_inserimento_riga: NextSDRDateTypes.LocalDateTime,
    data_ultima_modifica: NextSDRDateTypes.LocalDateTime
  };
}
class EntitaStoredProcedure {
  id_provenienza;
  schema;
  table;
  descrizione;
  additionalData;
  nextSdrDateInformation = {};
}
class KrintLogDescription {
  descrizioneOperazione;
  idUtente;
  descrizioneUtente;
  idOggetto;
  tipoOggetto;
  descrizioneOggetto;
  dataoraOperazione;
  nextSdrDateInformation = {
    dataoraOperazione: NextSDRDateTypes.ZonedDateTime
  };
}
class ItemMenu {
  id;
  descrizione;
  openCommand;
  icona;
  children;
  commandType;
  urlGenerationStrategy;
  nextSdrDateInformation = {};
}
const CommandType = {
  ROUTING: "ROUTING",
  COMPONENT: "COMPONENT",
  URL: "URL"
};
class RibaltoneDaLanciare {
  id;
  codiceAzienda;
  email;
  stato;
  dataInserimentoRiga;
  dataUltimaModifica;
  idUtente;
  idAzienda;
  note;
  strutture_spostate;
  trasforma;
  ribaltaInternauta;
  ribaltaArgo;
  ribaltaRubriche;
  log;
  version;
  trasformato;
  ribaltatoInternauta;
  ribaltatoArgo;
  fonteRibaltone;
  gruAperto;
  nextSdrDateInformation = {
    dataInserimentoRiga: NextSDRDateTypes.ZonedDateTime,
    dataUltimaModifica: NextSDRDateTypes.ZonedDateTime
  };
  fk_utente;
  fk_azienda;
}
class StoricoAttivazione {
  id;
  idAzienda;
  dataInserimentoRiga;
  ribaltaInternauta;
  ribaltaArgo;
  idUtente;
  note;
  version;
  fonteRibaltone;
  nextSdrDateInformation = {
    dataInserimentoRiga: NextSDRDateTypes.ZonedDateTime
  };
  fk_utente;
  fk_azienda;
}
class MdrAppartenenti {
  id;
  codiceEnte;
  codiceMatricola;
  cognome;
  nome;
  codiceFiscale;
  idCasella;
  datain;
  datafi;
  tipoAppartenenza;
  username;
  dataAssunzione;
  //dataDimissione: Date;
  idAzienda;
  nextSdrDateInformation = {
    dataAssunzione: NextSDRDateTypes.ZonedDateTime,
    datafi: NextSDRDateTypes.ZonedDateTime,
    datain: NextSDRDateTypes.ZonedDateTime
  };
}
class MdrResponsabili {
  id;
  codiceEnte;
  codiceMatricola;
  idCasella;
  datain;
  datafi;
  tipo;
  idAzienda;
  nextSdrDateInformation = {
    datafi: NextSDRDateTypes.ZonedDateTime,
    datain: NextSDRDateTypes.ZonedDateTime
  };
}
class MdrStruttura {
  id;
  codiceEnte;
  idPadre;
  idCasella;
  descrizione;
  datain;
  datafi;
  tipoLegame;
  idAzienda;
  nextSdrDateInformation = {
    datafi: NextSDRDateTypes.ZonedDateTime,
    datain: NextSDRDateTypes.ZonedDateTime
  };
}
class MdrTrasformazioni {
  id;
  progressivoRiga;
  idCasellaPartenza;
  idCasellaArrivo;
  datainPartenza;
  dataoraOper;
  dataTrasformazione;
  motivo;
  codiceEnte;
  idAzienda;
  nextSdrDateInformation = {
    datainPartenza: NextSDRDateTypes.ZonedDateTime,
    dataoraOper: NextSDRDateTypes.ZonedDateTime,
    dataTrasformazione: NextSDRDateTypes.ZonedDateTime
  };
}
class Predicato {
  id;
  predicato;
  descrizione;
  ruoliGestori;
  implicitiPerRuoli;
  fk_permessoList;
  nextSdrDateInformation = {};
}
class AmbitoSemantico {
  id;
  semantica;
  predicatiAmbiti;
  idPredicatiAmbiti;
  default_ambito;
  idAziende;
  nextSdrDateInformation = {};
}
class PredicatoAmbito {
  id;
  idPredicato;
  tipo;
  ambito;
  idPredicatiAmbitiAmbitiImpliciti;
  predicatiAmbitiAmbitiImpliciti;
  idAziende;
  ruoliGestori;
  nextSdrDateInformation = {};
}
class AttoreArchivioService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.scripta.attorearchivio, getInternautaUrl(BaseUrlType.Scripta));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: AttoreArchivioService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: AttoreArchivioService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: AttoreArchivioService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class ArchivioService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.scripta.archivio, getInternautaUrl(BaseUrlType.Scripta));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ArchivioService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ArchivioService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: ArchivioService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class ArchiviRecentiService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.scripta.archiviorecente, getInternautaUrl(BaseUrlType.Scripta));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ArchiviRecentiService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ArchiviRecentiService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: ArchiviRecentiService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class AttivitaService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.scrivania.attivita, getInternautaUrl(BaseUrlType.Scrivania));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: AttivitaService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: AttivitaService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: AttivitaService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class ArchivioDetailService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.scripta.archiviodetail, getInternautaUrl(BaseUrlType.Scripta));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ArchivioDetailService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ArchivioDetailService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: ArchivioDetailService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class ArchivioDetailViewService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.scripta.archiviodetailview, getInternautaUrl(BaseUrlType.Scripta));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ArchivioDetailViewService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ArchivioDetailViewService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: ArchivioDetailViewService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class ArchivioDocService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.scripta.archiviodoc, getInternautaUrl(BaseUrlType.Scripta));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ArchivioDocService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ArchivioDocService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: ArchivioDocService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class BlackboxPermessiService {
  _http;
  datepipe;
  constructor(_http, datepipe) {
    this._http = _http;
    this.datepipe = datepipe;
  }
  getPermessiArchivio(idArchivio, onlyPermissionsOfConnectedPersona = false) {
    const urlDaChiamare = getInternautaUrl(BaseUrlType.Permessi);
    const params = new HttpParams().set("idArchivio", idArchivio.toString()).set("onlyPermissionsOfConnectedPersona", onlyPermissionsOfConnectedPersona.toString());
    return this._http.get(urlDaChiamare + "/getPermessiArchivio", {
      params: params
    });
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: BlackboxPermessiService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: BlackboxPermessiService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: BlackboxPermessiService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class ImportazioniOrganigrammaService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.baborg.importazioniorganigramma, getInternautaUrl(BaseUrlType.Baborg));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ImportazioniOrganigrammaService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ImportazioniOrganigrammaService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: ImportazioniOrganigrammaService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class ContattoService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.rubrica.contatto, getInternautaUrl(BaseUrlType.Rubrica));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ContattoService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ContattoService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: ContattoService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class DettaglioContattoService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.rubrica.dettagliocontatto, getInternautaUrl(BaseUrlType.Rubrica));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: DettaglioContattoService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: DettaglioContattoService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: DettaglioContattoService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class ToolsService {
  _http;
  ToolsController = {
    GET_CLIENT_INFO: "getClientInfo",
    SEND_SMART_WORKING_MAIL: "sendSmartWorkingMail",
    INVIA_SEGNALAZIONE: "inviaSegnalazione"
  };
  constructor(_http) {
    this._http = _http;
  }
  getClientInfo() {
    const url = getInternautaUrl(BaseUrlType.Tools) + "/" + this.ToolsController.GET_CLIENT_INFO;
    return this._http.get(url);
  }
  sendSmartWorkingMail(data) {
    const url = getInternautaUrl(BaseUrlType.Tools) + "/" + this.ToolsController.SEND_SMART_WORKING_MAIL;
    return this._http.post(url, data);
  }
  inviaSegnalazione(data) {
    const url = getInternautaUrl(BaseUrlType.Tools) + "/" + this.ToolsController.INVIA_SEGNALAZIONE;
    return this._http.post(url, data, {
      responseType: "text"
    });
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ToolsService,
    deps: [{
      token: i1.HttpClient
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ToolsService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: ToolsService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }]
});
class ConfigurazioneService {
  _http;
  ConfigurazioneController = {
    GET_PARAMETRI_AZIENDE: "getParametriAziende",
    SAVE_ACCESSIBILTA: "saveAccessibilita",
    FIRMA_REMOTA_PROVIDERS: "firmaRemotaProviders",
    FIRMA_USER_SIGNS: "firmaRemotaUserSigns"
  };
  constructor(_http) {
    this._http = _http;
  }
  getParametriAziende(nome, idApplicazioni, idAziende) {
    const url = getInternautaUrl(BaseUrlType.Configurazione) + "/custom/" + this.ConfigurazioneController.GET_PARAMETRI_AZIENDE;
    let parametri = nome || idApplicazioni || idAziende ? "?" : "";
    parametri += nome ? "nome=" + nome : "";
    parametri += idApplicazioni || idAziende ? "&" : "";
    parametri += idApplicazioni ? "idApplicazioni=" + idApplicazioni : "";
    parametri += idAziende ? "&" : "";
    parametri += idAziende ? "idAziende=" + idAziende : "";
    return this._http.get(url + parametri);
  }
  getProvidersFirmaRemota() {
    const url = getInternautaUrl(BaseUrlType.Configurazione) + "/custom/" + this.ConfigurazioneController.FIRMA_REMOTA_PROVIDERS;
    return this._http.get(url);
  }
  getUserSignsFirmaRemota(username, tramiteFirma, hostId) {
    const url = getInternautaUrl(BaseUrlType.Configurazione) + "/custom/" + this.ConfigurazioneController.FIRMA_USER_SIGNS;
    let parametri = "?";
    parametri += "username=" + username + "&";
    parametri += "tramiteFirma=" + tramiteFirma + "&";
    parametri += "hostId=" + hostId;
    return this._http.get(url + parametri);
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ConfigurazioneService,
    deps: [{
      token: i1.HttpClient
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ConfigurazioneService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: ConfigurazioneService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }]
});
class PermessoDocService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.scripta.permessodoc, getInternautaUrl(BaseUrlType.Scripta));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: PermessoDocService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: PermessoDocService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: PermessoDocService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class ProjectedDocDetailService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.scripta.projecteddocdetail, getInternautaUrl(BaseUrlType.Scripta));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ProjectedDocDetailService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ProjectedDocDetailService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: ProjectedDocDetailService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class ProjectedDocDetailWithPermessoDocService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.scripta.projecteddocdetailwithpermessodoc, getInternautaUrl(BaseUrlType.Scripta));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ProjectedDocDetailWithPermessoDocService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ProjectedDocDetailWithPermessoDocService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: ProjectedDocDetailWithPermessoDocService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class AllegatoService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.scripta.allegato, getInternautaUrl(BaseUrlType.Scripta));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: AllegatoService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: AllegatoService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: AllegatoService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class MessageWithFolderViewService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.shpeck.messagewithfolderview, getInternautaUrl(BaseUrlType.Shpeck));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: MessageWithFolderViewService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: MessageWithFolderViewService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: MessageWithFolderViewService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class MessageWithTagViewService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.shpeck.messagewithtagview, getInternautaUrl(BaseUrlType.Shpeck));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: MessageWithTagViewService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: MessageWithTagViewService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: MessageWithTagViewService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class ProjectedMessageService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.shpeck.projectedmessage, getInternautaUrl(BaseUrlType.Shpeck));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ProjectedMessageService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ProjectedMessageService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: ProjectedMessageService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class ProjectedMessageForTagFilterService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.shpeck.projectedmessagefortagfilter, getInternautaUrl(BaseUrlType.Shpeck));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ProjectedMessageForTagFilterService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ProjectedMessageForTagFilterService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: ProjectedMessageForTagFilterService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class TitoloOLDService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.scripta.titolo, getInternautaUrl(BaseUrlType.Scripta));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: TitoloOLDService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: TitoloOLDService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: TitoloOLDService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class TitoloService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.titolario.titolo, getInternautaUrl(BaseUrlType.Titolario));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: TitoloService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: TitoloService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: TitoloService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class ContattiListFastService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.rubrica.contattocondettaglioprincipale, getInternautaUrl(BaseUrlType.Rubrica));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ContattiListFastService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ContattiListFastService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: ContattiListFastService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class CollegioSindacaleService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.scripta.collegiosindacale, getInternautaUrl(BaseUrlType.Scripta));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: CollegioSindacaleService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: CollegioSindacaleService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: CollegioSindacaleService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class MassimarioOLDService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.scripta.massimario, getInternautaUrl(BaseUrlType.Scripta));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: MassimarioOLDService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: MassimarioOLDService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: MassimarioOLDService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class MassimarioService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.titolario.massimario, getInternautaUrl(BaseUrlType.Titolario));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: MassimarioService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: MassimarioService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: MassimarioService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class ArchivioDiInteresseService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.scripta.archiviodiinteresse, getInternautaUrl(BaseUrlType.Scripta));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ArchivioDiInteresseService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ArchivioDiInteresseService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: ArchivioDiInteresseService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class AutorizzatoreModificheDocumentaliService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.scrivania.autorizzatoremodifichedocumentali, getInternautaUrl(BaseUrlType.Scrivania));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: AutorizzatoreModificheDocumentaliService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: AutorizzatoreModificheDocumentaliService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: AutorizzatoreModificheDocumentaliService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class SupportedFileService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.tools.supportedfile, getInternautaUrl(BaseUrlType.Tools));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: SupportedFileService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: SupportedFileService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: SupportedFileService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class VersamentoService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.versatore.versamento, getInternautaUrl(BaseUrlType.Versatore));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: VersamentoService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: VersamentoService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: VersamentoService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class SessioneImportazioneService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.tip.sessioneimportazione, getInternautaUrl(BaseUrlType.Tip));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: SessioneImportazioneService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: SessioneImportazioneService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: SessioneImportazioneService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class ImportazioneDocumentoService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.tip.importazionedocumento, getInternautaUrl(BaseUrlType.Tip));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ImportazioneDocumentoService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ImportazioneDocumentoService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: ImportazioneDocumentoService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class NoteVersamentoService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.scripta.noteversamento, getInternautaUrl(BaseUrlType.Scripta));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: NoteVersamentoService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: NoteVersamentoService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: NoteVersamentoService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class LottoService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.lotti.lotto, getInternautaUrl(BaseUrlType.Lotti));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: LottoService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: LottoService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: LottoService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class GruppoLottoService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.lotti.gruppolotto, getInternautaUrl(BaseUrlType.Lotti));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: GruppoLottoService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: GruppoLottoService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: GruppoLottoService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class ComponenteService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.lotti.componente, getInternautaUrl(BaseUrlType.Lotti));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ComponenteService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: ComponenteService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: ComponenteService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class DocDocService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.scripta.docdoc, getInternautaUrl(BaseUrlType.Scripta));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /**Metodo per trovare tutti i doc collegati ad un idSorgente */
  getDocsDocsByIdDocSorgente(idDocSorgente) {
    const url = getInternautaUrl(BaseUrlType.Scripta) + "/" + CUSTOM_SERVER_METHODS.getDocDocByIdDocSorgente + "/" + idDocSorgente;
    return this._http.get(url);
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: DocDocService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: DocDocService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: DocDocService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class JobService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.masterjobs.job, getInternautaUrl(BaseUrlType.Masterjobs));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: JobService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: JobService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: JobService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class RegistroCreazioneService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.titolario.registrocreazione, getInternautaUrl(BaseUrlType.Titolario));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: RegistroCreazioneService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: RegistroCreazioneService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: RegistroCreazioneService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class MassimarioTitoloService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.titolario.massimariotitolo, getInternautaUrl(BaseUrlType.Titolario));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: MassimarioTitoloService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: MassimarioTitoloService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: MassimarioTitoloService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});
class VersioneService extends NextSDREntityProvider {
  _http;
  _datepipe;
  constructor(_http, _datepipe) {
    super(_http, _datepipe, ENTITIES_STRUCTURE.titolario.versione, getInternautaUrl(BaseUrlType.Titolario));
    this._http = _http;
    this._datepipe = _datepipe;
  }
  /** @nocollapse */
  static ɵfac = i0.ɵɵngDeclareFactory({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: VersioneService,
    deps: [{
      token: i1.HttpClient
    }, {
      token: i2.DatePipe
    }],
    target: i0.ɵɵFactoryTarget.Injectable
  });
  /** @nocollapse */
  static ɵprov = i0.ɵɵngDeclareInjectable({
    minVersion: "12.0.0",
    version: "19.0.6",
    ngImport: i0,
    type: VersioneService,
    providedIn: "root"
  });
}
i0.ɵɵngDeclareClassMetadata({
  minVersion: "12.0.0",
  version: "19.0.6",
  ngImport: i0,
  type: VersioneService,
  decorators: [{
    type: Injectable,
    args: [{
      providedIn: "root"
    }]
  }],
  ctorParameters: () => [{
    type: i1.HttpClient
  }, {
    type: i2.DatePipe
  }]
});

/*
 * Public API Surface of internauta-model
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AFFERENZA_STRUTTURA, AZIENDA_CORRENTE, AddresRoleType, Address, AfferenzaStruttura, AfferenzaStrutturaService, Allegato, AllegatoService, AmbitiSemanticiService, AmbitoSemantico, AmministrazioneMessaggiService, AmministrazioneMessaggio, AnomaliaArchivioDetail, Applicazione, ApplicazioneService, Applicazioni, ArchiviRecentiService, Archivio, ArchivioDetail, ArchivioDetailService, ArchivioDetailView, ArchivioDetailViewService, ArchivioDiInteresse, ArchivioDiInteresseService, ArchivioDoc, ArchivioDocService, ArchivioRecente, ArchivioService, Attivita, AttivitaFatta, AttivitaService, AttoreArchivio, AttoreArchivioService, AttoreDoc, AttributiStruttura, AutorizzatoreModificheDocumentali, AutorizzatoreModificheDocumentaliService, Azienda, AziendaService, BaseUrlType, BaseUrls, BlackboxPermessiService, CODICI_AZIENDA, CODICI_REGISTRO, CODICI_RUOLO, CUSTOM_SERVER_METHODS, CategoriaContatto, CategoriaPermessiStoredProcedure, CodiceMezzo, CollegioSindacale, CollegioSindacaleDetail, CollegioSindacaleDoc, CollegioSindacaleService, CommandType, CommandTypeDoc, Componente, ComponenteService, Configuration, ConfigurazioneService, ContattiConflittuali, ContattiListFastService, Contatto, ContattoConDettaglioPrincipale, ContattoService, Contraente, DecimaleAnomaliaArchivioDetail, DecimaleAttributoVisibilita, DecimalePredicato, Destinatario, DettaglioAllegato, DettaglioContatto, DettaglioContattoService, Doc, DocDetail, DocDetailService, DocDetailView, DocDetailViewService, DocDoc, DocDocService, DocService, DominiAruba, DominiFirma, DominioAruba, DominioFirma, DominioFirmaService, Draft, DraftLite, ENTITIES_STRUCTURE, Email, EntitaStoredProcedure, Firmatario, FirmatarioAllegato, FirmatarioObject, FirmePersona, FirmePersonaService, FluxPermission, Folder, FolderType, GruppiContatti, GruppoCSV, GruppoLotto, GruppoLottoService, ImportazioneDocumento, ImportazioneDocumentoService, ImportazioniOrganigramma, ImportazioniOrganigrammaService, ImpostazioniApplicazioni, InOut, Indirizzo, IndirizzoSpedizione, InternautaModelModule, InvasivitaEnum, ItemMenu, Job, JobService, JobState, KRINT_TIPO_OGGETTO, KrintLogDescription, KrintService, LOCALHOST_PORT, Lotto, LottoService, MODULI_RUOLO, Massimario, MassimarioOLD, MassimarioOLDService, MassimarioService, MassimarioTitolo, MassimarioTitoloService, MdrAppartenenti, MdrResponsabili, MdrStruttura, MdrTrasformazioni, Menu, Message, MessageAddress, MessageDoc, MessageFolder, MessageRelatedType, MessageStatus, MessageTag, MessageType, MessageWithFolderView, MessageWithFolderViewService, MessageWithTagView, MessageWithTagViewService, Mezzo, MezzoService, Monitoraggio, MonitoraggioService, MotivazioneConflitto, Note, NoteVersamento, NoteVersamentoService, OperazioneRegistroCreazione, OrigineRelated, Outbox, OutboxLite, ParametriAzienda, ParametroAziende, ParametroAziendeService, Pec, PecAzienda, PecPermission, PecProvider, PermessoArchivio, PermessoDoc, PermessoDocService, PermessoEntitaStoredProcedure, PermessoStoredProcedure, Persona, PersonaService, PersonaUsante, Predicato, PredicatoAmbito, ProjectedDocDetail, ProjectedDocDetailService, ProjectedDocDetailWithPermessoDoc, ProjectedDocDetailWithPermessoDocService, ProjectedMessageForTagFilterService, ProjectedMessageService, Provider, RawMessage, Recepit, RecepitType, Registro, RegistroCreazione, RegistroCreazioneService, RegistroDoc, Related, RelatedService, RibaltoneDaLanciare, Ruolo, RuoloAttoreArchivio, RuoloAttoreDoc, RuoloComponente, SessioneImportazione, SessioneImportazioneService, SessioneVersamento, Set, SetPriority, SeveritaEnum, Smistamento, SmistamentoService, SottotipoAllegato, Spedizione, SpedizioneService, SqlSimilarityContact, SqlSimilarityResult, SqlSimilarityResults, StatiFirmatario, StatoArchivio, StatoDoc, StatoImportazioneDocumento, StatoUfficioAtti, StatoVersamento, StatusMonitoraggio, StoricoAttivazione, StoricoRelazione, StoricoRelazioneService, Struttura, StrutturaService, StrutturaUnificata, StrutturaUnificataService, SupportedFile, SupportedFileService, Tag, TagType, Telefono, TemplateMessaggiService, TemplateMessaggio, TipiFirma, TipoAllegato, TipoArchivio, TipoCollegamentoDoc, TipoContatto, TipoDettaglio, TipoDettaglioAllegato, TipoDettaglioAllegatoKeys, TipoGruppo, TipoRelated, Tipologia, TipologiaDoc, TipologiaEnum, TipologiaFirma, TipologiaSessioneVersamento, TipologiaStruttura, TipologiaStrutturaService, TipologieDocumentiTip, Titolo, TitoloOLD, TitoloOLDService, TitoloService, ToolsService, TramiteFirma, UrlsGenerationStrategy, Utente, UtenteService, UtenteStruttura, UtenteStrutturaService, Versamento, VersamentoAllegato, VersamentoService, Versione, VersioneService, VisibilitaDoc, getInternautaUrl };
